import { InformacionActivoComponent } from './../components/popups/activos/informacion-activo/informacion-activo.component';
import { Activo, ActivoUltimaTransmision } from './../../../_entities/activos/activo';
import { async } from '@angular/core/testing';
import { GuardarPuntoInteresComponent } from './../components/dialogos/puntos-interes/guardar-punto-interes/guardar-punto-interes.component';
import { GuardarGeocercaComponent } from './../components/dialogos/geocercas/guardar-geocerca/guardar-geocerca.component';
import { InformacionMicromedidorComponent } from './../components/popups/micromedidores/informacion-micromedidor/informacion-micromedidor.component';
import { InformacionMedidorComponent } from './../components/popups/medidores/informacion-medidor/informacion-medidor.component';
import { MedidoresService } from './medidores.service';
import { IconosService } from './iconos.service';
//import { PopupMicromedidorComponent } from './../popus/popup-micromedidor/popup-micromedidor.component';
//import { MedidoresService } from './../medidores/medidores-service/medidores.service';
import { Medidores } from '../../../_entities/medidores/Medidores';
import { HostListener, Injectable } from '@angular/core';
import Map from 'ol/Map.js';
import View from 'ol/View.js';
import TileLayer from 'ol/layer/Tile.js';
import VectorLayer from 'ol/layer/Vector.js';
import VectorSource from 'ol/source/Vector.js';
import Overlay from 'ol/Overlay';
import Feature from 'ol/Feature.js';
import Point from 'ol/geom/Point.js';
import Style from 'ol/style/Style.js';
import Fill from 'ol/style/Fill.js';
import Stroke from 'ol/style/Stroke.js';
import Circle from 'ol/style/Circle.js'
//import { Circle as CircleStyle } from 'ol/style';
import Icon from 'ol/style/Icon.js';
import Draw from 'ol/interaction/Draw.js';
import Snap from 'ol/interaction/Snap.js';
import Select from 'ol/interaction/Select.js';
import Modify from 'ol/interaction/Modify.js';
import { createStringXY } from 'ol/coordinate.js';
import OLGoogleMaps from 'olgm/OLGoogleMaps.js';
import GoogleLayer from 'olgm/layer/Google.js';
import { google } from "google-maps";
import GeoJSON from 'ol/format/GeoJSON.js'
import LineString from 'ol/geom/LineString.js';
import { defaults as defaultInteractions } from 'olgm/interaction.js';
import { addProjection, addCoordinateTransforms, transform, fromLonLat } from 'ol/proj.js';
import { getCenter } from 'ol/extent';
import OSMSource from 'ol/source/OSM.js';
import { XYZ } from 'ol/source';
import { CorrdenadasLngLaT } from '../../../_entities/coordenadas/Coordenadas';
import { Autos } from '../../../_entities/autos/Autos';
import { MatDialogConfig, MatDialog, MatDialogRef } from '@angular/material';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
//import { PopusComponent } from '../popus/popus.component';
import { DatePipe } from '@angular/common';
import { ToggleAction } from '@ngrx/store-devtools/src/actions';
//import { GetIconosService } from './get-iconos';
import { Cluster } from 'ol/source';
import { Text } from 'ol/style';
import { InformacionVehiculoComponent } from '../components/popups/vehiculos/informacion-vehiculo/informacion-vehiculo.component';
import { TelefonoUltimaTransmision } from '../../../_entities/telefonos/telefono';
import { InformacionTelefonoComponent } from '../components/popups/telefonos/informacion-telefono/informacion-telefono.component';
//import { PasoPuntoComponent } from '../popus/paso-punto/paso-punto.component';
//import { PopupMedidorComponent } from '../popus/popup-medidor/popup-medidor.component';
import { toLonLat } from 'ol/proj';
import { getBottomLeft, getTopRight } from 'ol/extent';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';
import { OSM } from 'ol/source';
import { defaults as defaultControls, ScaleLine, FullScreen } from 'ol/control';
import { StreetViewComponent } from '../components/popups/street-view/street-view.component';
import { PopupRecorridoHistoricoComponent } from '../components/popups/popup-recorrido-historico/popup-recorrido-historico.component';
import { Subject, Observable } from 'rxjs';
import { Vector } from 'html2canvas/dist/types/render/vector';
import { IGNICIONES } from './../../../_entities/estados';
import TileWMS from 'ol/source/TileWMS';
import { Permiso } from './../../../_entities/Enums/permiso.enum';
import { UltimaLectura } from './../../../_entities/terminal/terminal';
import { Micromedidor } from './../../../_entities/micromedidores/micromedidor';
import { IconosActivos, IconosTelefonos, SpinnerApuntador } from './../../../_entities/iconos';
import { SemaforoModalComponent } from '../components/dialogos/semaforo/semaforo-modal/semaforo-modal.component';
import { MedidorModalComponent } from '../components/dialogos/medidores/medidor-modal/medidor-modal.component';
import { MicromedidorModalComponent } from '../components/dialogos/micromedidores/micromedidor-modal/micromedidor-modal.component';
import { ActivoModalComponent } from '../components/dialogos/activos/activo-modal/activo-modal.component';
import { TelefonoModalComponent } from '../components/dialogos/telefonos/telefono-modal/telefono-modal.component';
import { AlertasComponent } from '../components/dialogos/alertas/alertas.component';
import { User } from '../../../_entities/User';
import { PortatilUltimaTransmision } from '../../../_entities/Portatiles/Portatil';
import { InformacionPortatilComponent } from '../components/popups/portatiles/informacion-portatil/informacion-portatil.component';
import { PortatilModalComponent } from '../components/dialogos/portatiles/portatil-modal/portatil-modal.component';
import { PanelCiudadano } from '../../../_entities/panelCiudadano/panelCiudadano';
import { InformacionPanelComponent } from '../components/popups/paneles/informacion-panel/informacion-panel.component';

@Injectable({
	providedIn: 'root'
})
export class MapaService {
	/*Declaracion de variables */
	/**Generales */
	_user: User;
	public spinnerNombre: string;
	public monitoreo = false;
	public sonProductosFiltrados: boolean = false;
	public drawPoint;
	public historicoFechas;
	public datepipe: DatePipe = new DatePipe('en-US');
	public usuariosFlitro;
	public clusterActivo: boolean = true
	public datosFueraGeocerca;
	public pintarEtiquetas: boolean = true;


	/**Dialogoso Semaforo */
	public autosMovimiento;
	public autosDetenidosRojo;
	public autosDetenidosNaranja;
	public autosExcesoAzul;
	public autosDetenidosAmarillo;
	public autosDetenidos;
	/**Capas*/
	public trafficLayer = new google.maps.TrafficLayer();
	public transitLayer = new google.maps.TransitLayer();
	public bicyclingLayer = new google.maps.BicyclingLayer();

	/**Toogles */
	public toogleActivos = true;
	public toogleMedidores = true;
	public toogleMicromedidores = true;
	public toogleTelefonos = true;
	public toogleVehiculos = true;
	public toggleParaSiempre;
	public tooglePortatiles = true;
	/**Popup */
	public overlayPopupHover: Overlay;
	public containerPopupHover: any;
	public contentPopupHover: any;

	public overlayClusterPopupHover: Overlay;
	public containerClusterPopupHover: any;
	public contentClusterPopupHover: any;

	/**Etiquetas */
	public overlayEtiquetas: Overlay;
	public containerEtiquetas: any;
	public datosGenerales: any;
	public tipoProducto: string;
	public controlEtiquetas = true;

	/**Etiquetas para siempre */
	public etiquetasActivos = [];
	public etiquetasLectoras = [];
	public etiquetasMedidores = [];
	public etiquetasMicromedidores = [];
	public etiquetasTelefonos = [];
	public etiquetasVehiculos = [];
	public etiquetasPortatiles = [];
	public etiquetasPaneles=[];
	/**Datos globales */
	public registroVehiculos: Autos[];
	public productosVisibles: boolean = false; //Debe iniciar en false

	/**Coordenadas*/
	public coordenadas: any;
	public coordenadaPI: any;

	/**Geocercas */
	public vectorGeoCercaSource = new VectorSource;
	public vectorGeoCercaLayer: VectorLayer;
	public geoCercaStyle = new Style({
		fill: new Fill({
			color: 'rgba(255,0,0,0.3)'
		}),
		stroke: new Stroke({
			color: '#ffcc33',
			width: 2
		}),
		image: new Circle({
			radius: 7,
			fill: new Fill({
				color: '#ffcc33'
			})
		})
	});
	public nuevaGeoCerca: any = {};
	public nuevaGeoCerca4326: any = {};
	public geo: GeoJSON;
	public geoJSON4326: GeoJSON;
	public snap: Snap;
	public feature: any;
	public featureGeoJSON: any;
	public drawGeoCerca: Draw;
	public dataFeature: any;
	public esGeocerca: boolean = false;

	/**Historico */
	public historicoMode = false;
	public iconHistoricoFeature: Feature;
	public vectorHistoricoSource: VectorSource;
	public vectorHistoricoLayer: VectorLayer;
	public iconHistoricoStyle: Style;
	public overlayGifMarkerRecorrido: Overlay;
	public overlayPopup: Overlay;
	public containerPopup: any;
	public contentPopup: any;
	public closerPopup: any;
	private informacionRecorrio = new Subject<any>();
	public informacionInicial;
	public ubicacionHistorico;
	private modoHistorico = new Subject<any>();
	public estadoHistorico;

	/**Recorrido */
	public mostrandoRecorrido = false;
	public posicionesReporte = [];
	public indexActualRecorrido = 0;
	public posicionActualRecorrido: any;

	/**Apuntador */
	public iconApuntadorFeature: Feature;
	public vectorApuntadorSource: VectorSource;
	public vectorApuntadorLayer: VectorLayer;
	public iconApuntador: Style;

	/**Producto ubicado */
	public iconoDispositivoUbicadoFeature: Feature;
	public vectorDispositivoUbicadoSource: VectorSource;
	public vectorDispositivoUbicadoLayer: VectorLayer;
	public iconoDispositivoUbicado: Style;

	/**Producto seleccionado */
	public iconApuntadorSelectFeature: Feature;
	public vectorApuntadorSelectSource: VectorSource;
	public vectorApuntadorSelectLayer: VectorLayer;
	public iconSelectApuntador: Style;
	public idAutoSeleccionado = '';

	/**Alertas */
	public vectorApuntadorAlertaSource: VectorSource;
	public vectorApuntadorAlertaLayer: VectorLayer;

	/*Contadores*/
	public alertaPrincipal = this.iconosPng.alertaPrincipal;
	public alertaPanel = this.iconosPng.alertaPrincipal;

	public alertaSecundaria = this.iconosPng.alertaSecundaria;
	public alertaGeocerca = this.iconosPng.alertaGeocerca;
	public alertaEnergia = this.iconosPng.alertaEnergia;
	public alertaBateria = this.iconosPng.alertaBateria;

	/**Seccion Productos */
	//**Activos */
	public iconActivosFeature: Feature;
	public iconActivosStyle: Style;
	public vectorActivosSource: VectorSource;
	public vectorActivosLayer: VectorLayer;
	public vectorClusterActivosLayer: VectorLayer;
	public activosDisponibles: ActivoUltimaTransmision[] = [];

	//**Portatiles */
	public iconPortatilesFeature: Feature;
	public iconPortatilesStyle: Style;
	public vectorPortatilesSource: VectorSource;
	public vectorPortatilesLayer: VectorLayer;
	public vectorClusterPortatilesLayer: VectorLayer;
	public portatilesDisponibles: PortatilUltimaTransmision[] = [];



	//**Howen */
	private videosDisponibles = new Subject<any>();
	public valorLey;

	//**Lectoras */
	public iconoLectorasFeature: Feature;
	public iconoLectorasStyle: Style;
	public vectorLectorasSource: VectorSource;
	public vectorLectorasLayer: VectorLayer;
	public vectorClusterLectorasLayer: VectorLayer;
	public lectorasDisponibles: UltimaLectura[] = [];

	//**Medidores */
	public iconMedidoresFeature: Feature;
	public iconMedidoresStyle: Style;
	public vectorMedidoresSource: VectorSource;
	public vectorMedidoresLayer: VectorLayer;
	public vectorClusterMedidoresLayer: VectorLayer;
	public medidoresDisponibles: Medidores[] = [];


	//**Paneles */
	public iconPanelesFeature: Feature;
	public iconPanelesStyle: Style;
	public vectorPanelesSource: VectorSource;
	public vectorPanelesLayer: VectorLayer;
	public vectorClusterPanelesLayer: VectorLayer;
	public panelesDisponibles: PanelCiudadano[] = [];


	//**Micromedidores */
	public iconMicromedidoresFeature: Feature;
	public iconMicromedidoresStyle: Style
	public vectorMicromedidoresSource: VectorSource;
	public vectorMicromedidoresLayer: VectorLayer;
	public vectorClusterMicromedidoresLayer: VectorLayer;
	public micromedidoresDisponibles: Micromedidor[] = [];

	/**Paso Punto */
	public iconoPasoPuntoFeature: Feature;
	public vectorPasoPuntoSource: VectorSource;
	public vectorPasoPuntoLayer: VectorLayer;
	public iconoPasoPuntoStyle: Style;

	//**Puntos de interes */
	public iconPInteresFeature: Feature;
	public iconPInteresStyle: Style;
	public vectorPInteresSource: VectorSource;
	public vectorPInteresLayer: VectorLayer;
	public vectorClusterPInteresLayer: VectorLayer;
	public puntosInteresDisponibles: any[] = [];

	public indexFinalRecorrido = 0;
	public sourcePi = new VectorSource({ wrapX: false });
	public vectorClusterPuntosInteresLayer = VectorLayer;

	//**Telefonos */
	public iconTelefonosFeature: Feature;
	public iconTelefonosStyle: Style;
	public vectorTelefonosSource: VectorSource;
	public vectorTelefonosLayer: VectorLayer;
	public vectorClusterTelefonosLayer: VectorLayer;
	public telefonosDisponibles: TelefonoUltimaTransmision[] = [];

	//**Vehiculos */
	public iconoVehiculoFeature: Feature;
	public vectorMarcadorVehiculosSource: VectorSource;
	public vectorMarcadorVehiculosLayer: VectorLayer;
	public iconVehiculosStyle: Style;
	public vectorClusterVehiculosLayer: VectorLayer;
	public vehiculosDisponibles: Autos[] = [];

	/**Mapa */
	public olGM: OLGoogleMaps;
	public map: Map;
	//public center = [-101.3770056, 23.8636449];
	public center = [-102.6827462, 24.3566658]
	public googleLayer = new GoogleLayer();
	public osmLayer: TileLayer;

	constructor(public dialog: MatDialog,
		private http: HttpClient,
		private toastr: ToastrService,
		private iconosPng: IconosService,
		private medidoresService: MedidoresService,
		private auth: AuthService) { }

	/**Se inicia el Mapa y sus componentes */
	public inicializarMapa = () => {
		/**Popup */
		this.containerPopup = document.getElementById('popup');
		this.contentPopup = document.getElementById('popup-content');
		this.closerPopup = document.getElementById('popup-closer');

		this.containerPopupHover = document.getElementById('popupHover');
		this.contentPopupHover = document.getElementById('popup-contentHover');

		this.containerClusterPopupHover = document.getElementById('popupClusterHover');
		this.contentClusterPopupHover = document.getElementById('popup-ClustercontentHover');


		this.overlayGifMarkerRecorrido = new Overlay({
			position: undefined,
			positioning: 'center-center',
			element: document.getElementById('posicionActualGif'),
			stopEvent: false,
			autoPan: true,
		});

		this.overlayPopup = new Overlay({
			position: undefined,
			element: this.containerPopup,
			autoPan: true,
			autoPanAnimation: {
				duration: 250
			}
		});

		this.overlayPopupHover = new Overlay({
			position: undefined,
			element: this.containerPopupHover,
			autoPan: true,
			autoPanAnimation: {
				duration: 250
			}
		});

		this.overlayClusterPopupHover = new Overlay({
			position: undefined,
			element: this.containerClusterPopupHover,
			autoPan: true,
			autoPanAnimation: {
				duration: 250
			}
		})

		/**Geocercas */
		this.vectorGeoCercaLayer = new VectorLayer({
			source: this.vectorGeoCercaSource,
			visible: true
		});

		/**Historico */
		this.vectorHistoricoSource = new VectorSource({});
		this.vectorHistoricoLayer = new VectorLayer({
			source: this.vectorHistoricoSource,
			updateWhileAnimating: true,
			updateWhileInteracting: true,
		});

		/**Apuntador historico */
		this.vectorApuntadorSource = new VectorSource({});
		this.vectorApuntadorLayer = new VectorLayer({
			source: this.vectorApuntadorSource,
			updateWhileAnimating: true,
			updateWhileInteracting: true,
		});

		/**Producto ubicado */
		this.vectorDispositivoUbicadoSource = new VectorSource({});
		this.vectorDispositivoUbicadoLayer = new VectorLayer({
			source: this.vectorDispositivoUbicadoSource,
			updateWhileAnimating: true,
			updateWhileInteracting: true,
		});

		/**Producto seleccionado */
		this.vectorApuntadorSelectSource = new VectorSource({});
		this.vectorApuntadorSelectLayer = new VectorLayer({
			source: this.vectorApuntadorSelectSource,
			updateWhileAnimating: true,
			updateWhileInteracting: true,
		});

		/**Alertas */
		this.vectorApuntadorAlertaSource = new VectorSource({});
		this.vectorApuntadorAlertaLayer = new VectorLayer({
			source: this.vectorApuntadorAlertaSource,
			updateWhileAnimating: true,
			updateWhileInteracting: true,
		});

		/**Seccion Productos */
		//**Activos */
		this.vectorActivosSource = new VectorSource({});
		this.vectorActivosLayer = new VectorLayer({
			source: this.vectorActivosSource,
			updateWhileAnimating: true,
			updateWhileInteracting: true,
		});

		this.vectorPortatilesSource = new VectorSource({});
		this.vectorPortatilesLayer = new VectorLayer({
			source: this.vectorPortatilesSource,
			updateWhileAnimating: true,
			updateWhileInteracting: true,
		});

		/**Lectoras */
		this.vectorLectorasSource = new VectorSource({});
		this.vectorLectorasLayer = new VectorLayer({
			source: this.vectorLectorasSource,
			updateWhileAnimating: true,
			updateWhileInteracting: true,
		});

		/**Medidores */
		this.vectorMedidoresSource = new VectorSource({});
		this.vectorMedidoresLayer = new VectorLayer({
			source: this.vectorMedidoresSource,
			updateWhileAnimating: true,
			updateWhileInteracting: true,
		});

		/**Micromedidores */
		this.vectorMicromedidoresSource = new VectorSource({});
		this.vectorMicromedidoresLayer = new VectorLayer({
			source: this.vectorMicromedidoresSource,
			updateWhileAnimating: true,
			updateWhileInteracting: true,
		});

		
		/**Paneles */
		this.vectorPanelesSource = new VectorSource({});
		this.vectorPanelesLayer = new VectorLayer({
			source: this.vectorPanelesSource,
			updateWhileAnimating: true,
			updateWhileInteracting: true,
		});


		/**Puntos de interes */
		this.vectorPInteresSource = new VectorSource({});
		this.vectorPInteresLayer = new VectorLayer({
			source: this.vectorPInteresSource,
			updateWhileAnimating: true,
			updateWhileInteracting: true,
		});

		/**Paso por punto */
		this.vectorPasoPuntoSource = new VectorSource({});
		this.vectorPasoPuntoLayer = new VectorLayer({
			source: this.vectorPasoPuntoSource,
			updateWhileAnimating: true,
			updateWhileInteracting: true,
		});

		/**Telefonos */
		this.vectorTelefonosSource = new VectorSource({});
		this.vectorTelefonosLayer = new VectorLayer({
			source: this.vectorTelefonosSource,
			updateWhileAnimating: true,
			updateWhileInteracting: true,
		});

		/**Vehiculos */
		this.vectorMarcadorVehiculosSource = new VectorSource({});
		this.vectorMarcadorVehiculosLayer = new VectorLayer({
			source: this.vectorMarcadorVehiculosSource,
			updateWhileAnimating: true,
			updateWhileInteracting: true,
		});

		/**Mapa */
		this.osmLayer = new TileLayer({
			source: new OSMSource(),
			visible: false
		});

		const extentMexico = [-13550795, 1150943, -8934498, 4384675];
		const extentCostaRica = [-9695336.0963200516998768, 613096.5521554843289778, -9189739.5557411331683397, 1256701.7956394979264587];

		//Esta capa ficticia le dice a Google Maps que cambie a su tipo de mapa predeterminado
		this.map = new Map({
			// use las interacciones predeterminadas recomendadas de OL3-Google-Maps
			interactions: defaultInteractions(),
			layers: [
				this.googleLayer,
				//this.osmLayer,
				this.vectorActivosLayer,
				this.vectorPortatilesLayer,
				this.vectorLectorasLayer,
				this.vectorMedidoresLayer,
				this.vectorMicromedidoresLayer,
				this.vectorPInteresLayer,
				this.vectorPasoPuntoLayer,
				this.vectorTelefonosLayer,
				this.vectorPanelesLayer,
				this.vectorMarcadorVehiculosLayer,
				this.vectorHistoricoLayer,
				this.vectorGeoCercaLayer,
				this.vectorApuntadorLayer,
				this.vectorApuntadorAlertaLayer,
				this.vectorApuntadorSelectLayer,
				this.vectorDispositivoUbicadoLayer,
			],
			overlays: [
				this.overlayPopup,
				this.overlayPopupHover,
				this.overlayClusterPopupHover
			],
			target: 'map',
			view: new View({
				center: fromLonLat(this.center),
				//extent: extentMexico,
				zoom: 0
			}),
			controls: defaultControls({ attribution: true, zoom: false }).extend([])
		});

		this.olGM = new OLGoogleMaps({
			map: this.map,
			mapIconOptions: {
				useCanvas: true
			},
			gmapOptions: {
				streetViewControl: false,
			},
			watch: {
				'vector': false
			}
		});

		this.olGM.activate();
		this.mouseHover();
		this.mouseClicked();
		this.onZoom();
	}

	/**Desplregar Activos en mapa */
	public pintarActivos = (activos: ActivoUltimaTransmision[]) => {
		this.activosDisponibles = activos;
		if (this.productosVisibles) {
			this.pintarMarcadoresActivos();
		} else {
			this.pintarClusterActivos();
		}
	}

	pintarClusterActivos() {
		if (this.activosDisponibles.length > 0) {
			let cluster = new Cluster({});
			let source = new VectorSource({});
			let feature: Feature;
			let styleCache = {};

			this.activosDisponibles.forEach(activo => {
				try {
					feature = new Feature({
						type: 'Activos',
						idActivo: activo.id,
						data: activo,
						dataTooltip: `divActivo${activo.id}`,
						geometry: new Point(transform(activo.coordinate, 'EPSG:4326', 'EPSG:3857'))
					});

				} catch {
					feature = new Feature({
						type: 'Activos',
						idActivo: activo.id,
						data: activo,
						dataTooltip: `divActivo${activo.id}`,
						geometry: new Point(transform([activo.lng, activo.lat], 'EPSG:4326', 'EPSG:3857'))
					});
				}

				source.addFeature(feature);
			});

			cluster.setDistance(40);
			cluster.setSource(source);

			this.vectorClusterActivosLayer = new VectorLayer({
				name: 'ClusterActivo',
				source: cluster,
				style: function (feature) {
					const size = feature.get('features').length;
					let style = styleCache[size];
					if (!style) {
						if (size > 1) {
							style = new Style({
								image: new Icon({
									anchor: [0.5, 0.5],
									anchorXUnits: 'fraction',
									anchorYUnits: 'fraction',
									src: './assets/image/cluster_activos.png'
								}),
								text: new Text({
									text: size.toString(),
									stroke: new Stroke({
										width: 1,
										color: '#fff',
									}),
									fill: new Fill({
										color: '#fff',
									}),
								}),
							});
							styleCache[size] = style;
						} else {
							style = new Style({
								image: new Icon({
									anchor: [0.5, 0.5],
									anchorXUnits: 'fraction',
									anchorYUnits: 'fraction',
									src: './assets/media/activos/activo.png'
								}),
							});
							styleCache[size] = style;
						}
					}
					return style;
				},
			});
			this.map.addLayer(this.vectorClusterActivosLayer);
		}
	}

	pintarMarcadoresActivos() {
		if (this.activosDisponibles.length > 0) {
			this.vectorActivosSource.clear();
			this.activosDisponibles.forEach(activo => {
				let icono: string;
				try {
					let iconoActivo = IconosActivos.find(icono => icono.id === activo.estado)
					icono = iconoActivo.icono
				} catch {
					icono = './assets/media/activos/activo.png'
				}

				try {
					this.iconActivosFeature = new Feature({
						type: 'activo',
						idActivo: activo.id,
						data: activo,
						dataTooltip: `divActivo${activo.id}`,
						geometry: new Point(transform(activo.coordinate, 'EPSG:4326', 'EPSG:3857'))
					});


				} catch {
					this.iconActivosFeature = new Feature({
						type: 'activo',
						idActivo: activo.id,
						data: activo,
						dataTooltip: `divActivo${activo.id}`,
						geometry: new Point(transform([activo.lng, activo.lat], 'EPSG:4326', 'EPSG:3857'))
					});

				}

				this.iconActivosStyle = new Style({
					image: new Icon({
						anchor: [0.5, 0.5],
						anchorXUnits: 'fraction',
						anchorYUnits: 'fraction',
						src: icono
					}),
					zIndex: 10
				});

				this.iconActivosFeature.setStyle(this.iconActivosStyle);
				this.vectorActivosSource.addFeature(this.iconActivosFeature);
				const coordenadasFeature = this.iconActivosFeature.getGeometry().getCoordinates();
				this.crearEtiquetaActivo(activo, coordenadasFeature);

				if (!this.pintarEtiquetas)
					this.ocultarEtiquetasActivos();
			});
		}
	}

	async crearEtiquetaActivo(activo: ActivoUltimaTransmision, coordenadasFeature) {
		let divActivo = `divActivo${activo.id}`;
		let overlayEtiqueta = this.map.getOverlayById(divActivo);

		let existeEtiqueta = overlayEtiqueta == null ? false : true;

		if (existeEtiqueta && this.sonProductosFiltrados == false) {
			/*let idGPS = `spanGPS${activo.id}`;
			let spanGPS = <HTMLElement>document.getElementById(idGPS);*/

			let idIcono = `iGPS${activo.id}`;
			let iconGPS = <HTMLElement>document.getElementById(idIcono);

			let idLabel = `labelColor${activo.id}`;
			let divLabel = <HTMLElement>document.getElementById(idLabel);

			let idBateria = `spanBateriaActivo${activo.id}`;
			let spanBateria = <HTMLElement>document.getElementById(idBateria);

			spanBateria.innerHTML = 'Batería: ' + activo.bateria;
			//spanGPS.innerHTML = activo.gps;

			switch (activo.gps) {
				case 'Mala':
					iconGPS.style.marginRight = '3px';
					iconGPS.classList.add("fad", "fa-signal-alt-2");
					iconGPS.style.color = "#fff";
					divLabel.style.backgroundColor = 'red';
					//spanEstadoGps.style.color = 'red';
					break;
				case 'Buena':
					iconGPS.style.marginRight = '3px';
					iconGPS.classList.add("fad", "fa-signal-alt");
					iconGPS.style.color = "#fff";
					//spanEstadoGps.style.color = 'green';
					divLabel.style.backgroundColor = 'green';
					break;
				case 'Media':
					iconGPS.style.marginRight = '3px';
					iconGPS.classList.add("fad", "fa-signal-alt-3");
					iconGPS.style.color = "#fff";
					//spanEstadoGps.style.color = 'yellow';
					divLabel.style.backgroundColor = 'orange';
					break;
				default:
					break;
			}

			overlayEtiqueta.setPosition(coordenadasFeature);

		} else {
			let etiquetas = <HTMLDivElement>document.getElementById('etiquetas');
			let div = document.createElement('div');
			let modelo = document.createTextNode(activo.modelo);
			let br = document.createElement('div');

			br.style.display = 'block';
			br.style.width = '100%';

			let divEtiqueta = document.createElement('div');
			divEtiqueta.id = `labelColor${activo.id}`;
			divEtiqueta.style.textAlign = 'center'
			divEtiqueta.style.border = '1px solid';
			divEtiqueta.style.lineHeight = '1.6em';
			divEtiqueta.style.marginTop = "3px";
			divEtiqueta.style.marginBottom = "3px";

			let divBateria = document.createElement("div");
			divBateria.id = `divBateria${activo.id}`;

			let spanGPS = document.createElement("span");
			spanGPS.id = `spanGPS${activo.id}`;
			let gps = document.createTextNode(activo.gps);
			spanGPS.appendChild(gps);

			let spanBateria = document.createElement("span");
			spanBateria.id = `spanBateriaActivo${activo.id}`;
			let bateria = document.createTextNode('Batería: ' + activo.bateria);
			spanBateria.appendChild(bateria);

			let iconoEtiqueta = document.createElement("i");
			iconoEtiqueta.id = `iGPS${activo.id}`;
			let referencia = <HTMLDivElement>document.getElementById('map-content');
			div.appendChild(modelo);
			divEtiqueta.appendChild(iconoEtiqueta);
			divEtiqueta.appendChild(spanGPS);
			divBateria.appendChild(spanBateria);

			switch (activo.gps) {
				case 'Mala':
					iconoEtiqueta.style.marginRight = '3px';
					iconoEtiqueta.classList.add("fad", "fa-signal-alt-2");
					iconoEtiqueta.style.color = "#fff";
					divEtiqueta.style.backgroundColor = 'red';
					//spanEstadoGps.style.color = 'red';
					break;
				case 'Buena':
					iconoEtiqueta.style.marginRight = '3px';
					iconoEtiqueta.classList.add("fad", "fa-signal-alt");
					iconoEtiqueta.style.color = "#fff";
					//spanEstadoGps.style.color = 'green';
					divEtiqueta.style.backgroundColor = 'green';
					break;
				case 'Media':
					iconoEtiqueta.style.marginRight = '3px';
					iconoEtiqueta.classList.add("fad", "fa-signal-alt-3");
					iconoEtiqueta.style.color = "#fff";
					//spanEstadoGps.style.color = 'yellow';
					divEtiqueta.style.backgroundColor = 'orange';
					break;
				default:
					break;
			}

			div.appendChild(divEtiqueta);
			div.appendChild(divBateria);

			div.classList.add('ol-popupEtiquetaActivos');

			let idClass = div.id = `divActivo${activo.id}`;
			this.etiquetasActivos.push(idClass);
			etiquetas.parentNode.insertBefore(div, referencia);

			let containerEt = <HTMLDivElement>document.getElementById('divActivo' + activo.id);
			let overlay = this.overlayEtiquetas = new Overlay({
				id: `divActivo${activo.id}`,
				position: undefined,
				element: containerEt,
				idOverlay: `divActivo${activo.id}`,
			});
			this.map.addOverlay(overlay);
			this.overlayEtiquetas.setPosition(coordenadasFeature);
		}
		return;
	}

	public ocultarActivos() {
		if (this.activosDisponibles.length > 0) {
			this.vectorActivosLayer.setVisible(false);
			this.ocultarEtiquetasActivos();
		}
	}

	public mostrarActivos() {
		if (this.activosDisponibles.length > 0) {
			this.vectorActivosLayer.setVisible(true);
			this.mostrarEtiquetasActivos();
		}
	}

	/**Portatiles */
	public pintarPortatiles = (portatiles: PortatilUltimaTransmision[]) => {
		this.portatilesDisponibles = portatiles;
		if (this.productosVisibles) {
			this.pintarMarcadoresPortatiles();
		} else {
			this.pintarClusterPortatiles();
		}
	}


	pintarClusterPortatiles() {
		if (this.portatilesDisponibles.length > 0) {
			let cluster = new Cluster({});
			let source = new VectorSource({});
			let feature: Feature;
			let styleCache = {};

			this.portatilesDisponibles.forEach(portatil => {
				try {
					feature = new Feature({
						type: 'Portatiles',
						idActivo: portatil.id,
						data: portatil,
						dataTooltip: `divActivo${portatil.id}`,
						geometry: new Point(transform(portatil.coordinate, 'EPSG:4326', 'EPSG:3857'))
					});

				} catch {
					feature = new Feature({
						type: 'Portatiles',
						idActivo: portatil.id,
						data: portatil,
						dataTooltip: `divActivo${portatil.id}`,
						geometry: new Point(transform([portatil.lng, portatil.lat], 'EPSG:4326', 'EPSG:3857'))
					});
				}

				source.addFeature(feature);
			});

			cluster.setDistance(40);
			cluster.setSource(source);

			this.vectorClusterPortatilesLayer = new VectorLayer({
				name: 'ClusterPortatil',
				source: cluster,
				style: function (feature) {
					const size = feature.get('features').length;
					let style = styleCache[size];
					if (!style) {
						if (size > 1) {
							style = new Style({
								image: new Icon({
									anchor: [0.5, 0.5],
									anchorXUnits: 'fraction',
									anchorYUnits: 'fraction',
									src: './assets/image/cluster_activos.png'
								}),
								text: new Text({
									text: size.toString(),
									stroke: new Stroke({
										width: 1,
										color: '#fff',
									}),
									fill: new Fill({
										color: '#fff',
									}),
								}),
							});
							styleCache[size] = style;
						} else {
							style = new Style({
								image: new Icon({
									anchor: [0.5, 0.5],
									anchorXUnits: 'fraction',
									anchorYUnits: 'fraction',
									src: './assets/media/portatiles/Portatiles_marker.png'
								}),
							});
							styleCache[size] = style;
						}
					}
					return style;
				},
			});
			this.map.addLayer(this.vectorClusterPortatilesLayer);
		}
	}

	pintarMarcadoresPortatiles() {
		if (this.portatilesDisponibles.length > 0) {
			this.vectorPortatilesSource.clear();
			this.portatilesDisponibles.forEach(portatil => {
				let icono: string;
				try {
					let iconoActivo = IconosActivos.find(icono => icono.id === portatil.estado)
					icono = iconoActivo.icono
				} catch {
					icono = './assets/media/portatiles/Portatiles_24.png'
				}

				try {
					this.iconPortatilesFeature = new Feature({
						type: 'Portatiles',
						idActivo: portatil.id,
						data: portatil,
						dataTooltip: `divPortatil${portatil.id}`,
						geometry: new Point(transform(portatil.coordinate, 'EPSG:4326', 'EPSG:3857'))
					});


				} catch {
					this.iconPortatilesFeature = new Feature({
						type: 'Portatiles',
						idActivo: portatil.id,
						data: portatil,
						dataTooltip: `divPortatil${portatil.id}`,
						geometry: new Point(transform([portatil.lng, portatil.lat], 'EPSG:4326', 'EPSG:3857'))
					});

				}

				this.iconPortatilesStyle = new Style({
					image: new Icon({
						anchor: [0.5, 0.5],
						anchorXUnits: 'fraction',
						anchorYUnits: 'fraction',
						src: icono
					}),
					zIndex: 10
				});

				this.iconPortatilesFeature.setStyle(this.iconPortatilesStyle);
				this.vectorPortatilesSource.addFeature(this.iconPortatilesFeature);
				const coordenadasFeature = this.iconPortatilesFeature.getGeometry().getCoordinates();
				this.crearEtiquetaActivo(portatil, coordenadasFeature);

				if (!this.pintarEtiquetas)
					this.ocultarEtiquetasPortatiles();
			});
		}
	}

	async crearEtiquetaPortatil(portatil: PortatilUltimaTransmision, coordenadasFeature) {
		let divActivo = `divPortatil${portatil.id}`;
		let overlayEtiqueta = this.map.getOverlayById(divActivo);

		let existeEtiqueta = overlayEtiqueta == null ? false : true;

		if (existeEtiqueta && this.sonProductosFiltrados == false) {
			/*let idGPS = `spanGPS${activo.id}`;
			let spanGPS = <HTMLElement>document.getElementById(idGPS);*/

			let idIcono = `iGPS${portatil.id}`;
			let iconGPS = <HTMLElement>document.getElementById(idIcono);

			let idLabel = `labelColor${portatil.id}`;
			let divLabel = <HTMLElement>document.getElementById(idLabel);

			let idBateria = `spanBateriaActivo${portatil.id}`;
			let spanBateria = <HTMLElement>document.getElementById(idBateria);

			spanBateria.innerHTML = 'Batería: ' + portatil.bateria;
			//spanGPS.innerHTML = activo.gps;

			switch (portatil.gps) {
				case 'Mala':
					iconGPS.style.marginRight = '3px';
					iconGPS.classList.add("fad", "fa-signal-alt-2");
					iconGPS.style.color = "#fff";
					divLabel.style.backgroundColor = 'red';
					//spanEstadoGps.style.color = 'red';
					break;
				case 'Buena':
					iconGPS.style.marginRight = '3px';
					iconGPS.classList.add("fad", "fa-signal-alt");
					iconGPS.style.color = "#fff";
					//spanEstadoGps.style.color = 'green';
					divLabel.style.backgroundColor = 'green';
					break;
				case 'Media':
					iconGPS.style.marginRight = '3px';
					iconGPS.classList.add("fad", "fa-signal-alt-3");
					iconGPS.style.color = "#fff";
					//spanEstadoGps.style.color = 'yellow';
					divLabel.style.backgroundColor = 'orange';
					break;
				default:
					break;
			}

			overlayEtiqueta.setPosition(coordenadasFeature);

		} else {
			let etiquetas = <HTMLDivElement>document.getElementById('etiquetas');
			let div = document.createElement('div');
			let modelo = document.createTextNode(portatil.modelo);
			let br = document.createElement('div');

			br.style.display = 'block';
			br.style.width = '100%';

			let divEtiqueta = document.createElement('div');
			divEtiqueta.id = `labelColor${portatil.id}`;
			divEtiqueta.style.textAlign = 'center'
			divEtiqueta.style.border = '1px solid';
			divEtiqueta.style.lineHeight = '1.6em';
			divEtiqueta.style.marginTop = "3px";
			divEtiqueta.style.marginBottom = "3px";

			let divBateria = document.createElement("div");
			divBateria.id = `divBateria${portatil.id}`;

			let spanGPS = document.createElement("span");
			spanGPS.id = `spanGPS${portatil.id}`;
			let gps = document.createTextNode(portatil.gps);
			spanGPS.appendChild(gps);

			let spanBateria = document.createElement("span");
			spanBateria.id = `spanBateriaActivo${portatil.id}`;
			let bateria = document.createTextNode('Batería: ' + portatil.bateria);
			spanBateria.appendChild(bateria);

			let iconoEtiqueta = document.createElement("i");
			iconoEtiqueta.id = `iGPS${portatil.id}`;
			let referencia = <HTMLDivElement>document.getElementById('map-content');
			div.appendChild(modelo);
			divEtiqueta.appendChild(iconoEtiqueta);
			divEtiqueta.appendChild(spanGPS);
			divBateria.appendChild(spanBateria);

			switch (portatil.gps) {
				case 'Mala':
					iconoEtiqueta.style.marginRight = '3px';
					iconoEtiqueta.classList.add("fad", "fa-signal-alt-2");
					iconoEtiqueta.style.color = "#fff";
					divEtiqueta.style.backgroundColor = 'red';
					//spanEstadoGps.style.color = 'red';
					break;
				case 'Buena':
					iconoEtiqueta.style.marginRight = '3px';
					iconoEtiqueta.classList.add("fad", "fa-signal-alt");
					iconoEtiqueta.style.color = "#fff";
					//spanEstadoGps.style.color = 'green';
					divEtiqueta.style.backgroundColor = 'green';
					break;
				case 'Media':
					iconoEtiqueta.style.marginRight = '3px';
					iconoEtiqueta.classList.add("fad", "fa-signal-alt-3");
					iconoEtiqueta.style.color = "#fff";
					//spanEstadoGps.style.color = 'yellow';
					divEtiqueta.style.backgroundColor = 'orange';
					break;
				default:
					break;
			}

			div.appendChild(divEtiqueta);
			div.appendChild(divBateria);

			div.classList.add('ol-popupEtiquetaActivos');

			let idClass = div.id = `divPortatil${portatil.id}`;
			this.etiquetasActivos.push(idClass);
			etiquetas.parentNode.insertBefore(div, referencia);

			let containerEt = <HTMLDivElement>document.getElementById('divPortatil' + portatil.id);
			let overlay = this.overlayEtiquetas = new Overlay({
				id: `divPortatil${portatil.id}`,
				position: undefined,
				element: containerEt,
				idOverlay: `divPortatil${portatil.id}`,
			});
			this.map.addOverlay(overlay);
			this.overlayEtiquetas.setPosition(coordenadasFeature);
		}
		return;
	}

	public ocultarPortatiles() {
		if (this.portatilesDisponibles.length > 0) {
			this.vectorPortatilesLayer.setVisible(false);
			this.ocultarEtiquetasPortatiles();
		}
	}

	public mostrarPortatiles() {
		if (this.portatilesDisponibles.length > 0) {
			this.vectorPortatilesLayer.setVisible(true);
			this.mostrarEtiquetasPortatiles();
		}
	}


	/**Desplegar Lectoras en Mapa*/
	public pintarLectoras = (lectoras: UltimaLectura[]) => {
		this.lectorasDisponibles = lectoras;

		if (this.productosVisibles) {
			this.pintarMarcadoresLectoras();
		} else {
			this.pintarClusterLectoras();
		}

	}

	pintarClusterLectoras() {
		if (this.lectorasDisponibles.length > 0) {
			let source = new VectorSource({});
			let feature: Feature;
			let styleCache = {};

			this.lectorasDisponibles.forEach(lectora => {
				feature = new Feature({
					type: 'Lectoras',
					idActivo: lectora.id,
					data: lectora,
					dataTooltip: `divLectora${lectora.id}`,
					geometry: new Point(transform([lectora.lng, lectora.lat], 'EPSG:4326', 'EPSG:3857'))
				});
				source.addFeature(feature);
			});

			const CLUSTER = new Cluster({
				distance: 40,
				minDistance: 20,
				source: source,
			});

			this.vectorClusterLectorasLayer = new VectorLayer({
				source: CLUSTER,
				style: function (feature) {
					const size = feature.get('features').length;
					let style = styleCache[size];
					if (!style) {
						if (size > 1) {
							style = new Style({
								image: new Icon({
									anchor: [0.5, 0.5],
									anchorXUnits: 'fraction',
									anchorYUnits: 'fraction',
									src: './assets/image/Lectoras.png'
								}),
								text: new Text({
									text: size.toString(),
									stroke: new Stroke({
										width: 1,
										color: '#fff',
									}),
									fill: new Fill({
										color: '#fff',
									}),
								}),
							});
							styleCache[size] = style;
						} else {
							style = new Style({
								image: new Icon({
									anchor: [0.5, 0.5],
									anchorXUnits: 'fraction',
									anchorYUnits: 'fraction',
									src: './assets/media/terminales/Lectoras.png'
								}),
							});
							styleCache[size] = style;
						}

					}
					return style;
				},
			});
			this.map.addLayer(this.vectorClusterLectorasLayer);
		}
	}

	pintarMarcadoresLectoras() {
		if (this.lectorasDisponibles.length > 0) {
			this.vectorLectorasSource.clear();
			this.lectorasDisponibles.forEach(lectora => {
				this.iconoLectorasFeature = new Feature({
					type: 'lectora',
					idTelefono: lectora.id,
					data: lectora,
					dataTooltip: `divLectora${lectora.id}`,
					geometry: new Point(transform([lectora.lng, lectora.lat], 'EPSG:4326', 'EPSG:3857'))
				});

				this.iconoLectorasStyle = new Style({
					image: new Icon({
						anchor: [0.5, 0.5],
						anchorXUnits: 'fraction',
						anchorYUnits: 'fraction',
						src: './assets/media/terminales/Lectoras.png'
					}),
					zIndex: 10
				});
				this.iconoLectorasFeature.setStyle(this.iconoLectorasStyle);
				this.vectorLectorasSource.addFeature(this.iconoLectorasFeature);
			})
		}
	}

	public ocultarLectoras() {
		if (this.lectorasDisponibles.length > 0) {
			this.vectorLectorasLayer.setVisible(false);
		}
	}

	public mostrarLectoras() {
		if (this.lectorasDisponibles.length > 0) {
			this.vectorLectorasLayer.setVisible(true);
		}
	}




	

	/**Desplegar Medidores en Mapa */
	public pintarMedidores = (medidores: Medidores[]) => {
		this.medidoresDisponibles = medidores;

		if (this.productosVisibles) {
			this.pintarMarcadoresMedidores();
		} else {
			this.pintarClusterMedidores();
		}
	}



	pintarClusterMedidores() {
		if (this.medidoresDisponibles.length > 0) {
			let source = new VectorSource({});
			let feature: Feature;
			let styleCache = {};

			this.medidoresDisponibles.forEach(medidor => {
				feature = new Feature({
					type: 'Medidores',
					idActivo: medidor.id,
					data: medidor,
					dataTooltip: `divMedidor${medidor.id}`,
					geometry: new Point(transform([medidor.lng, medidor.lat], 'EPSG:4326', 'EPSG:3857'))
				});
				source.addFeature(feature);
			});

			const CLUSTER = new Cluster({
				distance: 40,
				minDistance: 20,
				source: source
			});

			this.vectorClusterMedidoresLayer = new VectorLayer({
				source: CLUSTER,
				style: function (feature) {
					const size = feature.get('features').length;
					let style = styleCache[size];
					if (!style) {
						if (size > 1) {
							style = new Style({
								image: new Icon({
									anchor: [0.5, 0.5],
									anchorXUnits: 'fraction',
									anchorYUnits: 'fraction',
									src: './assets/image/Hidraulicos.png'
								}),
								text: new Text({
									text: size.toString(),
									stroke: new Stroke({
										width: 1,
										color: '#fff',
									}),
									fill: new Fill({
										color: '#fff',
									}),
								}),
							});
							styleCache[size] = style;
						} else {
							style = new Style({
								image: new Icon({
									anchor: [0.5, 0.5],
									anchorXUnits: 'fraction',
									anchorYUnits: 'fraction',
									src: './assets/media/medidores/medidor.png'
								}),
							});
							styleCache[size] = style;
						}

					}
					return style;
				},
			});
			this.map.addLayer(this.vectorClusterMedidoresLayer);
		}
	}

	pintarMarcadoresMedidores() {
		if (this.medidoresDisponibles.length > 0) {
			this.medidoresDisponibles.forEach(medidor => {
				this.iconMedidoresFeature = new Feature({
					type: 'medidor',
					idMedidor: medidor.id,
					data: medidor,
					dataTooltip: `divMedidor${medidor.id}`,
					geometry: new Point(transform([medidor.lng, medidor.lat], 'EPSG:4326', 'EPSG:3857'))
				});

				this.iconMedidoresStyle = new Style({
					image: new Icon({
						anchor: [0.5, 0.5],
						anchorXUnits: 'fraction',
						anchorYUnits: 'fraction',
						src: './assets/media/medidores/medidor.png'
					}),
					zIndex: 10
				});
				this.iconMedidoresFeature.setStyle(this.iconMedidoresStyle);
				this.vectorMedidoresSource.addFeature(this.iconMedidoresFeature);

				const coordenaFeature = this.iconMedidoresFeature.getGeometry().getCoordinates();
				this.crearEtiquetaMedidor(medidor, coordenaFeature)

				if (!this.pintarEtiquetas)
					this.ocultarEtiquetasMedidores();
			});
		}
	}

	async crearEtiquetaMedidor(medidor, coordenaFeature) {
		let gastoData = "";
		let totalizadorData = "";
		this.medidoresService.obtenerMedidor(medidor.imei).subscribe(
			(response) => {
				if (response != null) {
					gastoData = response.gasto.toFixed(4).toString();
					totalizadorData = response.totalizador.toFixed(4).toString();
				}


				let divMedidor = `divMedidor${medidor.id}`;
				let overlayEtiqueta = this.map.getOverlayById(divMedidor);

				let existeEtiqueta = overlayEtiqueta == null ? false : true;
				if (existeEtiqueta && this.sonProductosFiltrados == false) {
					let idEstatus = `spanEstado${medidor.id}`;
					let imeiSpan = <HTMLElement>document.getElementById(idEstatus);
					let idLabel = `labelColor${medidor.id}`;
					let divLabel = <HTMLElement>document.getElementById(idLabel);

					imeiSpan.innerHTML = '' + medidor.imei;
					divLabel.style.backgroundColor = '#166BA2';

					overlayEtiqueta.setPosition(coordenaFeature);
				} else {
					let etiquetas = <HTMLDivElement>document.getElementById('etiquetas');
					let div = document.createElement("div");
					let gasto = document.createTextNode('Gasto: ' + gastoData + ' m3/h')
					let br = document.createElement("div");

					br.style.display = 'block';
					br.style.width = '100%';

					let divEtiqueta = document.createElement("div");
					divEtiqueta.id = `labelColor${medidor.id}`;
					divEtiqueta.style.border = '1px solid';
					divEtiqueta.style.lineHeight = '1.6em';
					divEtiqueta.style.marginTop = "3px";
					divEtiqueta.style.marginBottom = "3px";

					let divTotalizador = document.createElement("div");
					divTotalizador.id = `divTotalizador${medidor.id}`;

					let iconoEtiqueta = document.createElement("i");
					iconoEtiqueta.style.marginRight = '3px';
					iconoEtiqueta.classList.add("fal", "fa-barcode-alt");
					iconoEtiqueta.style.color = "#fff";

					let spanEstatus = document.createElement("span");
					spanEstatus.id = `spanEstado${medidor.id}`;
					let estatus = document.createTextNode(medidor.imei);
					spanEstatus.appendChild(estatus);

					let totalizadorMedidor = document.createElement("span");
					totalizadorMedidor.id = `spanTotalizadorMedidor${medidor.id}`;
					let totalizador = document.createTextNode('Totalizador: ' + totalizadorData + ' m3');
					totalizadorMedidor.appendChild(totalizador);


					let totalizadorMedidor2 = document.createElement("span");
					totalizadorMedidor2.id = `spanTotalizadorMedidor2${medidor.id}`;
					let totalizador2 = document.createTextNode(totalizadorData + ' m3');
					totalizadorMedidor2.appendChild(totalizador2);

					let referencia = <HTMLDivElement>document.getElementById('map-content');
					div.appendChild(gasto);
					divEtiqueta.appendChild(iconoEtiqueta);
					divEtiqueta.appendChild(spanEstatus);
					divTotalizador.appendChild(totalizadorMedidor)

					divEtiqueta.style.backgroundColor = '#166BA2';

					div.appendChild(divEtiqueta);
					div.appendChild(divTotalizador);

					div.classList.add('ol-popupEtiquetaMedidor');

					let idClass = div.id = `divMedidor${medidor.id}`;
					this.etiquetasMedidores.push(idClass);
					etiquetas.parentNode.insertBefore(div, referencia);

					let containerEt = <HTMLDivElement>document.getElementById('divMedidor' + medidor.id);
					let overlay = this.overlayEtiquetas = new Overlay({
						id: `divMedidor${medidor.id}`,
						position: undefined,
						element: containerEt,
						idOverlay: `divMedidor${medidor.id}`,
					});
					this.map.addOverlay(overlay);
					this.overlayEtiquetas.setPosition(coordenaFeature);
				}
				return;
			}
		);

	}

	public ocultarMedidores() {
		if (this.medidoresDisponibles.length > 0) {
			this.vectorMedidoresLayer.setVisible(false);
			this.ocultarEtiquetasMedidores();
		}
	}

	public mostrarMedidores() {
		if (this.medidoresDisponibles.length > 0) {
			this.vectorMedidoresLayer.setVisible(true);
			this.mostrarEtiquetasMedidores();
		}
	}






	/**Desplegar Micromedidores en Mapa*/
	public pintarMicromedidores = (micromedidores: Micromedidor[]) => {
		this.micromedidoresDisponibles = micromedidores;
		if (this.productosVisibles) {
			this.pintarMarcadoresMicromedidores()
		} else {
			this.pintarClusterMicromedidores()
		}
	}

	pintarClusterMicromedidores() {
		if (this.micromedidoresDisponibles.length > 0) {
			let source = new VectorSource({});
			let feature: Feature;
			let styleCache = {};

			this.micromedidoresDisponibles.forEach(micromedidor => {
				feature = new Feature({
					type: 'Micromedidores',
					idMicromedidor: micromedidor.id,
					data: micromedidor,
					dataTooltip: `divMicromedidor${micromedidor.id}`,
					geometry: new Point(transform([micromedidor.lng, micromedidor.lat], 'EPSG:4326', 'EPSG:3857'))

				});
				source.addFeature(feature);
			});

			const CLUSTER = new Cluster({
				distance: 40,
				minDistance: 20,
				source: source,
			});

			this.vectorClusterMicromedidoresLayer = new VectorLayer({
				source: CLUSTER,
				style: function (feature) {
					const size = feature.get('features').length;
					let style = styleCache[size];
					if (!style) {
						if (size > 1) {
							style = new Style({
								image: new Icon({
									anchor: [0.5, 0.5],
									anchorXUnits: 'fraction',
									anchorYUnits: 'fraction',
									src: './assets/image/Hidraulicos.png'
								}),
								text: new Text({
									text: size.toString(),
									stroke: new Stroke({
										width: 1,
										color: '#fff',
									}),
									fill: new Fill({
										color: '#fff',
									}),
								}),
							});
							styleCache[size] = style;
						} else {
							style = new Style({
								image: new Icon({
									anchor: [0.5, 0.5],
									anchorXUnits: 'fraction',
									anchorYUnits: 'fraction',
									src: './assets/media/medidores/medidor.png'
								}),
							});
							styleCache[size] = style;
						}

					}
					return style;
				},
			});
			this.map.addLayer(this.vectorClusterMicromedidoresLayer);
		}
	}

	pintarMarcadoresMicromedidores() {
		if (this.micromedidoresDisponibles.length > 0) {
			this.micromedidoresDisponibles.forEach(micromedidor => {
				this.iconMicromedidoresFeature = new Feature({
					type: 'micromedidor',
					idMicromedidor: micromedidor.id,
					data: micromedidor,
					dataTooltip: `divMicromedidor${micromedidor.id}`,
					geometry: new Point(transform([micromedidor.lng, micromedidor.lat], 'EPSG:4326', 'EPSG:3857')) //El servicio debe contener las coordenadas
				});

				this.iconMicromedidoresStyle = new Style({
					image: new Icon({
						anchor: [0.5, 0.5],
						anchorXUnits: 'fraction',
						anchorYUnits: 'fraction',
						src: './assets/media/medidores/medidor.png'
					}),
					zIndex: 10
				});

				this.iconMicromedidoresFeature.setStyle(this.iconMicromedidoresStyle);
				this.vectorMicromedidoresSource.addFeature(this.iconMicromedidoresFeature);
				const coordenaFeature = this.iconMicromedidoresFeature.getGeometry().getCoordinates();
				this.crearEtiquetaMicromedidor(micromedidor, coordenaFeature);

				if (!this.pintarEtiquetas)
					this.ocultarEtiquetasMicromedidores();
			});
		}

		// esta es una prueba del demo
		this._user = this.auth.getUser();
		if (this._user.id === "6cac2e07-cb6d-4725-93d7-ed7ad39f5ade") {
			var lat = 19.213896;
			var lng = -98.994782;
			this.iconMicromedidoresFeature = new Feature({
				type: 'micromedidor',
				idMicromedidor: '',
				data: '',
				dataTooltip: `divMicromedidor`,
				geometry: new Point(transform([lng, lat], 'EPSG:4326', 'EPSG:3857')) //El servicio debe contener las coordenadas
			});

			this.iconMicromedidoresStyle = new Style({
				image: new Icon({
					anchor: [0.5, 0.5],
					anchorXUnits: 'fraction',
					anchorYUnits: 'fraction',
					src: './assets/image/Garzas.png'
				}),
				zIndex: 10
			});

			this.iconMicromedidoresFeature.setStyle(this.iconMicromedidoresStyle);
			this.vectorMicromedidoresSource.addFeature(this.iconMicromedidoresFeature);
			const coordenaFeature = this.iconMicromedidoresFeature.getGeometry().getCoordinates();
			this.crearEtiquetaMicromedidor('', coordenaFeature);

			if (!this.pintarEtiquetas)
				this.ocultarEtiquetasMicromedidores();

		}
	}

	async crearEtiquetaMicromedidor(micromedidor, coordenaFeature) {
		let contador = micromedidor.contador

		let fechaFormato = this.datepipe.transform(micromedidor.fechaHora, "yyyy-MM-dd");
		let hora = this.datepipe.transform(micromedidor.fechaHora, "h:mma");

		let divMicromedidor = `divMicromedidor${micromedidor.numeroSerie}`;
		let overlayEtiqueta = this.map.getOverlayById(divMicromedidor);

		let existeEtiqueta = overlayEtiqueta == null ? false : true;
		if (existeEtiqueta && this.sonProductosFiltrados == false) {
			let totalizadorMedidor = document.createElement("span");
			totalizadorMedidor.id = `spanTotalizadorMedidor${micromedidor.id}`;
			let totalizador = document.createTextNode('Contador: ' + contador + ' l');
			totalizadorMedidor.appendChild(totalizador);

			overlayEtiqueta.setPosition(coordenaFeature);
		} else {
			let etiquetas = <HTMLDivElement>document.getElementById('etiquetas');
			let div = document.createElement("div");
			let fecha = document.createTextNode('Fecha: ' + fechaFormato);
			let br = document.createElement("div");

			br.style.display = 'block';
			br.style.width = '100%';

			let divEtiqueta = document.createElement("div");
			divEtiqueta.id = `idLabel${micromedidor.numeroSerie}`;

			divEtiqueta.style.border = '1px solid';
			divEtiqueta.style.lineHeight = '1.6em';
			divEtiqueta.style.marginTop = "3px";
			divEtiqueta.style.marginBottom = "3px";

			/**Div Numero de serie */
			let divTotalizador = document.createElement("div");
			divTotalizador.id = `divTotalizador${micromedidor.numeroSerie}`;

			/**Icono */
			let iconEtiqueta = document.createElement("i");
			iconEtiqueta.style.marginRight = '3px';
			iconEtiqueta.classList.add("fal", "fa-barcode-alt");
			iconEtiqueta.style.color = "#fff";


			let spanNumeroSerie = document.createElement("span");
			spanNumeroSerie.id = `spanNumeroSerie${micromedidor.id}`;
			let numeroSerie = document.createTextNode(micromedidor.numeroSerie);
			spanNumeroSerie.appendChild(numeroSerie);

			let totalizadorMedidor = document.createElement("span");
			totalizadorMedidor.id = `spanTotalizadorMedidor${micromedidor.id}`;
			let totalizador = document.createTextNode('Contador: ' + contador + ' l');
			totalizadorMedidor.appendChild(totalizador);

			let referencia = <HTMLDivElement>document.getElementById('map-content');
			div.appendChild(fecha);
			divEtiqueta.appendChild(iconEtiqueta);
			divEtiqueta.appendChild(spanNumeroSerie);
			divTotalizador.appendChild(totalizadorMedidor)

			divEtiqueta.style.backgroundColor = '#166BA2';

			div.appendChild(divEtiqueta);
			div.appendChild(divTotalizador);

			div.classList.add('ol-popupEtiquetaMicro');

			let idClass = div.id = `divMicromedidor${micromedidor.numeroSerie}`;
			this.etiquetasMicromedidores.push(idClass);
			etiquetas.parentNode.insertBefore(div, referencia);

			let containerEt = <HTMLDivElement>document.getElementById('divMicromedidor' + micromedidor.numeroSerie);
			let overlay = this.overlayEtiquetas = new Overlay({
				id: `divMicromedidor${micromedidor.numeroSerie}`,
				position: undefined,
				element: containerEt,
				idOverlay: `divMicromedidor${micromedidor.numeroSerie}`,
			});
			this.map.addOverlay(overlay);
			this.overlayEtiquetas.setPosition(coordenaFeature);
		}
		return;
	}

	/*este es una prueba del demo*/
	async crearEtiquetaMicromedidorDemo(micromedidor, coordenaFeature) {
		let contador = micromedidor.contador

		let fechaFormato = this.datepipe.transform(micromedidor.fechaHora, "yyyy-MM-dd");
		let hora = this.datepipe.transform(micromedidor.fechaHora, "h:mma");

		let divMicromedidor = `divMicromedidor${micromedidor.numeroSerie}`;
		let overlayEtiqueta = this.map.getOverlayById(divMicromedidor);

		let existeEtiqueta = overlayEtiqueta == null ? false : true;
		if (existeEtiqueta && this.sonProductosFiltrados == false) {
			let totalizadorMedidor = document.createElement("span");
			totalizadorMedidor.id = `spanTotalizadorMedidor${micromedidor.id}`;
			let totalizador = document.createTextNode('Contador: ' + contador + ' l');
			totalizadorMedidor.appendChild(totalizador);

			overlayEtiqueta.setPosition(coordenaFeature);
		} else {
			let etiquetas = <HTMLDivElement>document.getElementById('etiquetas');
			let div = document.createElement("div");
			let fecha = document.createTextNode('Fecha: 4/04/2022');
			let br = document.createElement("div");

			br.style.display = 'block';
			br.style.width = '100%';

			let divEtiqueta = document.createElement("div");
			divEtiqueta.id = `idLabel${micromedidor.numeroSerie}`;

			divEtiqueta.style.border = '1px solid';
			divEtiqueta.style.lineHeight = '1.6em';
			divEtiqueta.style.marginTop = "3px";
			divEtiqueta.style.marginBottom = "3px";

			/**Div Numero de serie */
			let divTotalizador = document.createElement("div");
			divTotalizador.id = `divTotalizador${micromedidor.numeroSerie}`;

			/**Icono */
			let iconEtiqueta = document.createElement("i");
			iconEtiqueta.style.marginRight = '3px';
			iconEtiqueta.classList.add("fal", "fa-barcode-alt");
			iconEtiqueta.style.color = "#fff";


			let spanNumeroSerie = document.createElement("span");
			spanNumeroSerie.id = `spanNumeroSerie${micromedidor.id}`;
			let numeroSerie = document.createTextNode('ub40acdc');
			spanNumeroSerie.appendChild(numeroSerie);

			let totalizadorMedidor = document.createElement("span");
			totalizadorMedidor.id = `spanTotalizadorMedidor${micromedidor.id}`;
			let totalizador = document.createTextNode('Estado: Activo');
			totalizadorMedidor.appendChild(totalizador);

			let referencia = <HTMLDivElement>document.getElementById('map-content');
			div.appendChild(fecha);
			divEtiqueta.appendChild(iconEtiqueta);
			divEtiqueta.appendChild(spanNumeroSerie);
			divTotalizador.appendChild(totalizadorMedidor)

			divEtiqueta.style.backgroundColor = '#166BA2';

			div.appendChild(divEtiqueta);
			div.appendChild(divTotalizador);

			div.classList.add('ol-popupEtiquetaMicro');

			let idClass = div.id = `divMicromedidor${micromedidor.numeroSerie}`;
			this.etiquetasMicromedidores.push(idClass);
			etiquetas.parentNode.insertBefore(div, referencia);

			let containerEt = <HTMLDivElement>document.getElementById('divMicromedidor' + micromedidor.numeroSerie);
			let overlay = this.overlayEtiquetas = new Overlay({
				id: `divMicromedidor${micromedidor.numeroSerie}`,
				position: undefined,
				element: containerEt,
				idOverlay: `divMicromedidor${micromedidor.numeroSerie}`,
			});
			this.map.addOverlay(overlay);
			this.overlayEtiquetas.setPosition(coordenaFeature);
		}
		return;
	}
	/*este es una prueba del demo*/

	public ocultarMicromedidores() {
		if (this.micromedidoresDisponibles.length > 0) {
			this.vectorMicromedidoresLayer.setVisible(false);
			this.ocultarEtiquetasMicromedidores();
		}
	}

	public mostrarMicromedidores() {
		if (this.micromedidoresDisponibles.length > 0) {
			this.vectorMicromedidoresLayer.setVisible(true);
			this.mostrarEtiquetasMicromedidores();
		}
	}

	/**Desplegar Puntos de interes en mapa*/
	public pintarPuntosInteres = (puntosInteres: any[]) => {
		this.puntosInteresDisponibles = puntosInteres;

		if (this.productosVisibles) {
			this.pintarMarcadoresPuntoInteres();
		} else {
			this.pintarClusterPuntosInteres();
		}
	}

	pintarClusterPuntosInteres() {
		if (this.puntosInteresDisponibles.length > 0) {
			let source = new VectorSource({});
			let feature: Feature;
			let styleCache = {};

			this.puntosInteresDisponibles.forEach(puntoInteres => {
				feature = new Feature({
					type: 'Puntos',
					data: puntoInteres,
					geometry: new Point(transform([puntoInteres.coordenadas[1], puntoInteres.coordenadas[0]], 'EPSG:4326', 'EPSG:3857'))
				});
				source.addFeature(feature);
			});

			const CLUSTER = new Cluster({
				distance: 40,
				minDistance: 20,
				source: source
			});

			this.vectorClusterPuntosInteresLayer = new VectorLayer({
				source: CLUSTER,
				style: function (feature) {
					const size = feature.get('features').length;
					let style = styleCache[size];
					if (!style) {
						style = new Style({
							image: new Icon({
								anchor: [0.5, 0.5],
								anchorXUnits: 'fraction',
								anchorYUnits: 'fraction',
								src: './assets/image/Puntos.png'
							}),
							text: new Text({
								text: size.toString(),
								stroke: new Stroke({
									width: 1,
									color: '#fff',
								}),
								fill: new Fill({
									color: '#fff',
								}),
							}),
						});
						styleCache[size] = style;
					}
					return style;
				},
			});
			this.map.addLayer(this.vectorClusterPuntosInteresLayer);
		}


	}

	pintarMarcadoresPuntoInteres() {
		if (this.puntosInteresDisponibles.length > 0) {
			this.puntosInteresDisponibles.forEach(puntoInteres => {
				this.iconPInteresFeature = new Feature({
					type: 'puntoInteres',
					data: puntoInteres,
					geometry: new Point(transform([puntoInteres.coordenadas[1], puntoInteres.coordenadas[0]], 'EPSG:4326', 'EPSG:3857'))
				});

				this.iconPInteresStyle = new Style({
					image: new Icon({
						anchor: [0.5, 0.5],
						anchorXUnits: 'fraction',
						anchorYUnits: 'fraction',
						src: puntoInteres.icono
					}),
					zIndex: 10
				});
				this.iconPInteresFeature.setStyle(this.iconPInteresStyle);
				this.vectorPInteresSource.addFeature(this.iconPInteresFeature);
			});
		}
	}

	/**Desplegar Telefonos en Mapa*/
	public pintarTelefonos = (telefonos: TelefonoUltimaTransmision[]) => {
		this.telefonosDisponibles = telefonos;

		if (this.productosVisibles) {
			this.pintarMarcadoresTelefonos();
		} else {
			this.pintarClusterTelefonos();
		}
	}

	pintarClusterTelefonos() {
		if (this.telefonosDisponibles.length > 0) {
			let source = new VectorSource({});
			let feature: Feature;
			let styleCache = {};

			this.telefonosDisponibles.forEach(telefono => {
				feature = new Feature({
					type: 'Telefonos',
					idTelefono: telefono.id,
					data: telefono,
					dataTooltip: `divTelefono${telefono.id}`,
					geometry: new Point(transform([telefono.lng, telefono.lat], 'EPSG:4326', 'EPSG:3857'))
				})
				source.addFeature(feature);
			});

			const CLUSTER = new Cluster({
				distance: 40,
				minDistance: 20,
				source: source
			});

			this.vectorClusterTelefonosLayer = new VectorLayer({
				source: CLUSTER,
				style: function (feature) {
					const size = feature.get('features').length;
					let style = styleCache[size];
					if (!style) {
						if (size > 1) {
							style = new Style({
								image: new Icon({
									anchor: [0.5, 0.5],
									anchorXUnits: 'fraction',
									anchorYUnits: 'fraction',
									src: './assets/image/Celulares.png'
								}),
								text: new Text({
									text: size.toString(),
									stroke: new Stroke({
										width: 1,
										color: '#fff',
									}),
									fill: new Fill({
										color: '#fff',
									}),
								}),
							});
							styleCache[size] = style;
						} else {
							style = new Style({
								image: new Icon({
									anchor: [0.5, 0.5],
									anchorXUnits: 'fraction',
									anchorYUnits: 'fraction',
									src: './assets/media/telefonos/telefono.png'
								}),
							});
							styleCache[size] = style;
						}

					}
					return style;
				},
			});
			this.map.addLayer(this.vectorClusterTelefonosLayer);
		}
	}

	pintarMarcadoresTelefonos() {
		if (this.telefonosDisponibles.length > 0) {
			this.telefonosDisponibles.forEach(telefono => {
				let icono: string;
				try {
					let iconoTelefono = IconosTelefonos.find(icono => icono.id === telefono.estado)
					icono = iconoTelefono.icono
				} catch {
					icono = './assets/media/telefonos/telefono.png'
				}

				this.iconTelefonosFeature = new Feature({
					type: 'telefono',
					idTelefono: telefono.id,
					data: telefono,
					dataTooltip: `divTelefono${telefono.id}`,
					geometry: new Point(transform([telefono.lng, telefono.lat], 'EPSG:4326', 'EPSG:3857'))
				});

				this.iconTelefonosStyle = new Style({
					image: new Icon({
						anchor: [0.5, 0.5],
						anchorXUnits: 'fraction',
						anchorYUnits: 'fraction',
						src: icono
					}),
					zIndex: 10
				});

				this.iconTelefonosFeature.setStyle(this.iconTelefonosStyle);
				this.vectorTelefonosSource.addFeature(this.iconTelefonosFeature);
				const coordenadasFeature = this.iconTelefonosFeature.getGeometry().getCoordinates();
				this.crearEtiquetaTelefono(telefono, coordenadasFeature);

				if (!this.pintarEtiquetas)
					this.ocultarEtiquetasTelefonos();

			});
		}
	}

	async crearEtiquetaTelefono(telefono, coordenadasFeature) {
		let divTelefono = `divTelefono${telefono.id}`;
		let overlayEtiqueta = this.map.getOverlayById(divTelefono);

		let yaExiste = overlayEtiqueta == null ? false : true;
		if (yaExiste && this.sonProductosFiltrados == false) {
			let idEstatus = `spanEstado${telefono.id}`;
			let idIcono = `iGPS${telefono.id}`;
			let iconGPS = <HTMLElement>document.getElementById(idIcono);
			let idLabel = `labelColor${telefono.id}`;
			let divLabel = <HTMLElement>document.getElementById(idLabel);

			switch (telefono.gps) {
				case 'Mala':
					iconGPS.style.marginRight = '3px';
					iconGPS.classList.add("fad", "fa-signal-alt-2");
					iconGPS.style.color = "#fff";
					divLabel.style.backgroundColor = 'red';
					//spanEstadoGps.style.color = 'red';
					break;
				case 'Buena':
					iconGPS.style.marginRight = '3px';
					iconGPS.classList.add("fad", "fa-signal-alt");
					iconGPS.style.color = "#fff";
					//spanEstadoGps.style.color = 'green';
					divLabel.style.backgroundColor = 'green';
					break;
				case 'Media':
					iconGPS.style.marginRight = '3px';
					iconGPS.classList.add("fad", "fa-signal-alt-3");
					iconGPS.style.color = "#fff";
					//spanEstadoGps.style.color = 'yellow';
					divLabel.style.backgroundColor = 'orange';
					break;
				default:
					break;
			}

			overlayEtiqueta.setPosition(coordenadasFeature);
		} else {
			let etiquetas = <HTMLDivElement>document.getElementById('etiquetas');
			let div = document.createElement('div');
			let modelo = document.createTextNode(telefono.modelo);
			let br = document.createElement('div');

			br.style.display = 'block';
			br.style.width = '100%';

			let label = document.createElement('div');
			label.id = `labelColor${telefono.id}`;
			label.style.border = '1px solid';
			label.style.lineHeight = '1.6em';
			label.style.marginTop = "3px";
			label.style.marginBottom = "3px";
			label.style.textAlign = 'center';

			let divBateria = document.createElement("div");
			divBateria.id = `divBateria${telefono.id}`;

			let iconE = document.createElement("i");
			iconE.id = `iGPS${telefono.id}`;

			let spanBateria = document.createElement("span");
			spanBateria.id = `spanBateriaTelefono${telefono.id}`;
			let bateria = document.createTextNode('Batería: ' + telefono.bateria);
			spanBateria.appendChild(bateria);

			let spanGPS = document.createElement("span");
			spanGPS.id = `spanGPS${telefono.id}`;
			let gps = document.createTextNode(telefono.gps);
			spanGPS.appendChild(gps);

			let referencia = <HTMLDivElement>document.getElementById('map-content');
			div.appendChild(modelo);
			label.appendChild(iconE);
			label.appendChild(spanGPS);
			divBateria.appendChild(spanBateria);


			label.style.backgroundColor = 'green';

			switch (telefono.gps) {
				case 'Mala':
					iconE.style.marginRight = '3px';
					iconE.classList.add("fad", "fa-signal-alt-2");
					iconE.style.color = "#fff";
					label.style.backgroundColor = 'red';
					//spanEstadoGps.style.color = 'red';
					break;
				case 'Buena':
					iconE.style.marginRight = '3px';
					iconE.classList.add("fad", "fa-signal-alt");
					iconE.style.color = "#fff";
					//spanEstadoGps.style.color = 'green';
					label.style.backgroundColor = 'green';
					break;
				case 'Media':
					iconE.style.marginRight = '3px';
					iconE.classList.add("fad", "fa-signal-alt-3");
					iconE.style.color = "#fff";
					//spanEstadoGps.style.color = 'yellow';
					label.style.backgroundColor = 'orange';
					break;
				default:
					break;
			}
			div.appendChild(label);
			div.appendChild(divBateria);
			div.classList.add('ol-popupEtiqueta');

			let idClass = div.id = `divTelefono${telefono.id}`;
			this.etiquetasTelefonos.push(idClass);
			etiquetas.parentNode.insertBefore(div, referencia);

			let containerEt = <HTMLDivElement>document.getElementById('divTelefono' + telefono.id);
			let overlay = this.overlayEtiquetas = new Overlay({
				id: `divTelefono${telefono.id}`,
				position: undefined,
				element: containerEt,
				idOverlay: `divTelefono${telefono.id}`,
			});
			this.map.addOverlay(overlay);
			this.overlayEtiquetas.setPosition(coordenadasFeature);
		}

		return;
	}

	public ocultarTelefonos() {
		if (this.telefonosDisponibles.length > 0) {
			this.vectorTelefonosLayer.setVisible(false);
			this.ocultarEtiquetasTelefonos();
		}
	}

	public mostrarTelefonos() {
		if (this.telefonosDisponibles.length > 0) {
			this.vectorTelefonosLayer.setVisible(true);
			this.mostrarEtiquetasTelefonos();
		}
	}

	/**Desplegar Vehiculos en Mapa */
	public pintarVehiculos = (vehiculos: Autos[]) => {
		this.vehiculosDisponibles = vehiculos;
		if (this.productosVisibles) {
			this.pintarMarcadoresVehiculos();
		} else {
			this.pintarClusterVehiculos();
		}

	}

	pintarClusterVehiculos() {
		if (this.vehiculosDisponibles.length > 0) {
			let source = new VectorSource({});
			let feature: Feature;
			let styleCache = {};
			this.vehiculosDisponibles.forEach(vehiculo => {
				feature = new Feature({
					type: 'Vehiculos',
					idVehiculo: vehiculo.id,
					data: vehiculo,
					dataTooltip: `divAuto${vehiculo.id}`,
					geometry: new Point(fromLonLat([vehiculo.lng, vehiculo.lat]))
				});
				source.addFeature(feature);
			});

			const CLUSTER = new Cluster({
				distance: 40,
				minDistance: 20,
				source: source
			});

			this.vectorClusterVehiculosLayer = new VectorLayer({
				source: CLUSTER,
				style: function (feature) {
					const size = feature.get('features').length;
					let style = styleCache[size];
					if (!style) {
						if (size > 1) {
							style = new Style({
								image: new Icon({
									anchor: [0.5, 0.5],
									anchorXUnits: 'fraction',
									anchorYUnits: 'fraction',
									src: './assets/image/Vehiculos.png'
								}),
								text: new Text({
									text: size.toString(),
									stroke: new Stroke({
										width: 1,
										color: '#fff',
									}),
									fill: new Fill({

										color: '#fff',
									}),
								}),
							});
							styleCache[size] = style;
						} else {
							style = new Style({
								image: new Icon({
									anchor: [0.5, 0.5],
									anchorXUnits: 'fraction',
									anchorYUnits: 'fraction',
									src: './assets/media/autos/auto_gris.png'
								}),
							});
							styleCache[size] = style;
						}

					}
					return style;
				},
			});
			this.map.addLayer(this.vectorClusterVehiculosLayer);
		}
	}

	pintarMarcadoresVehiculos() {
		this.vectorMarcadorVehiculosSource.clear();
		if (this.vehiculosDisponibles.length > 0) {
			const EstadosValidos = [2, 3, 8, 9, 10];
			this.vehiculosDisponibles.forEach(vehiculo => {
				if (EstadosValidos.includes(vehiculo.estado)) {
					this.pintarApuntadorAlertas(vehiculo);
				}
				this.iconoVehiculoFeature = new Feature({
					type: 'vehiculo',
					idVehiculo: vehiculo.id,
					data: vehiculo,
					dataTooltip: `divAuto${vehiculo.id}`,
					geometry: new Point(fromLonLat([vehiculo.lng, vehiculo.lat]))
				});

				this.iconVehiculosStyle = new Style({
					image: new Icon({
						anchor: [0.5, 0.5],
						anchorXUnits: 'fraction',
						anchorYUnits: 'fraction',
						src: this.iconosPng.colorVehiculos(vehiculo),
						rotation: this.gradesToRadians(vehiculo.direccion)
					})
				});

				this.iconVehiculosStyle.setZIndex(999);
				this.iconoVehiculoFeature.setStyle(this.iconVehiculosStyle);
				this.vectorMarcadorVehiculosSource.addFeature(this.iconoVehiculoFeature);

				let coordenadaFeature = this.iconoVehiculoFeature.getGeometry().getCoordinates();
				this.crearEtiquetaVehiculos(vehiculo, coordenadaFeature);

				if (!this.pintarEtiquetas)
					this.ocultarEtiquetasVehiculos();
			});
		}

	}

	pintarApuntadorAlertas(vehiculo) {
		let spinner = SpinnerApuntador.find(spiner => spiner.id === vehiculo.estado);
		let iconoSpiner = spinner.icono;

		let coordenadas = fromLonLat([vehiculo.lng, vehiculo.lat]);
		let apuntadorFeature = new Feature({
			type: 'puntoApuntadorAlerta',
			geometry: new Point(coordenadas)
		});

		let iconStyleApuntador = new Style({
			image: new Icon({
				anchor: [0.5, 0.5],
				anchorXUnits: 'fraction',
				anchorYUnits: 'fraction',
				src: iconoSpiner
			}),
			zIndex: 10
		});

		apuntadorFeature.setStyle(iconStyleApuntador);
		this.vectorApuntadorAlertaSource.addFeature(apuntadorFeature);
	}

	async crearEtiquetaVehiculos(vehiculo, coordenadaFeature) {
		let divAuto = `divAuto${vehiculo.id}`;
		let overlayEtiqueta = this.map.getOverlayById(divAuto);
		let estadoMovimiento = '';

		switch (vehiculo.estaEnMovimiento) {
			case false:
				estadoMovimiento = 'Detenido';
				break;
			case true:
				estadoMovimiento = 'Movimiento';
				break;
			default:
				break;
		}

		let existeEtiqueta = overlayEtiqueta == null ? false : true;

		if (existeEtiqueta && this.sonProductosFiltrados == false) {
			let idEstado = `spanEstado${vehiculo.id}`;
			let estadoSpan = <HTMLElement>document.getElementById(idEstado);
			let idLabel = `labelColor${vehiculo.id}`;
			let divLabel = <HTMLElement>document.getElementById(idLabel);

			if (estadoSpan !== null) {
				if (vehiculo.estaEnMovimiento == true) {
					estadoSpan.innerHTML = '' + estadoMovimiento;
					divLabel.style.backgroundColor = 'green';
				} else if (vehiculo.estaEnMovimiento == false) {
					estadoSpan.innerHTML = '' + estadoMovimiento;
					divLabel.style.backgroundColor = 'red';
				}
			}

			let idVelocidad = `spanVelocidad${vehiculo.id}`;
			let velocidadSpan = <HTMLElement>document.getElementById(idVelocidad);
			if (velocidadSpan !== null) {
				velocidadSpan.innerHTML = '' + vehiculo.velocidad + ' Km/h';
			}

			overlayEtiqueta.setPosition(coordenadaFeature);
		} else {
			let div = <HTMLDivElement>document.getElementById('etiquetas');

			let spanEconomico = document.createElement('span');
			spanEconomico.id = `spanEconomico${vehiculo.id}`;
			let economico = document.createTextNode(vehiculo.economico);
			spanEconomico.appendChild(economico);

			let newDiv = document.createElement("div");
			let newContent = document.createTextNode(vehiculo.marca);
			let divBr = document.createElement("div");
			divBr.style.display = 'block';
			divBr.style.width = '100%';

			let label = document.createElement("div");
			label.id = `labelColor${vehiculo.id}`;
			label.style.textAlign = 'center';
			label.style.border = '1px solid';
			label.style.lineHeight = '1.6em';
			label.style.marginTop = "3px";
			label.style.marginBottom = "3px";

			let iconE = document.createElement("i");
			iconE.style.marginRight = '3px';
			iconE.classList.add("fal", "fa-map-marker-alt");
			iconE.style.color = "#fff";
			let spanEstado = document.createElement("span");
			spanEstado.id = `spanEstado${vehiculo.id}`;
			let estado = document.createTextNode(estadoMovimiento);
			spanEstado.appendChild(estado);
			let spanVelocidad = document.createElement("span");
			spanVelocidad.id = `spanVelocidad${vehiculo.id}`;
			let vel = document.createTextNode('' + vehiculo.velocidad + ' Km/h');
			spanVelocidad.appendChild(vel);
			let referencia = <HTMLDivElement>document.getElementById('map-content');

			newDiv.appendChild(spanEconomico);
			//newDiv.appendChild(newContent);

			label.appendChild(iconE);
			label.appendChild(spanEstado);
			if (vehiculo.estaEnMovimiento == true) {
				label.style.backgroundColor = 'green';
			} else if (vehiculo.estaEnMovimiento == false) {
				label.style.backgroundColor = 'red';
			}
			newDiv.appendChild(label);
			newDiv.appendChild(spanVelocidad);
			newDiv.classList.add('ol-popupEtiqueta');
			let idClass = newDiv.id = `divAuto${vehiculo.id}`;
			this.etiquetasVehiculos.push(idClass);
			div.parentNode.insertBefore(newDiv, referencia);
			let containerEt = <HTMLDivElement>document.getElementById('divAuto' + vehiculo.id);
			let overlay = this.overlayEtiquetas = new Overlay({
				id: `divAuto${vehiculo.id}`,
				position: undefined,
				element: containerEt,
				idOverlay: `divAuto${vehiculo.id}`,
			});
			this.map.addOverlay(overlay);
			this.overlayEtiquetas.setPosition(coordenadaFeature);
		}
		return;
	}

	gradesToRadians(degree) {
		var pi = Math.PI;
		return (degree * (pi / 180)) * -1;
	}


	public ocultarVehiculos = () => {
		if (this.vehiculosDisponibles.length > 0) {
			this.vectorMarcadorVehiculosLayer.setVisible(false);
			this.ocultarEtiquetasVehiculos();
		}
	}

	public mostrarVehiculos = () => {
		if (this.vehiculosDisponibles.length > 0) {
			this.vectorMarcadorVehiculosLayer.setVisible(true);
			this.vectorGeoCercaLayer.setVisible(false);
			this.mostrarEtiquetasVehiculos();
		}
	}

	public ocultarApuntadorAlertas() {
		if (this.vehiculosDisponibles.length > 0) {
			this.vectorApuntadorAlertaLayer.setVisible(false);
		}
	}

	public mostrarApuntadorAlertas() {
		if (this.vehiculosDisponibles.length > 0) {
			this.vectorApuntadorAlertaLayer.setVisible(true);
		}
	}


	/**Desplegar Geocercas */
	public ubicarGeocerca = (data: any) => {
		var featureGeocerca = this.getGeocercaFeature(data);
		var extent = featureGeocerca.getGeometry().getExtent();
		this.map.getView().fit(extent);
		this.vectorGeoCercaLayer.setVisible(true);
	}

	public getGeocercaFeature = (data: any) => {
		var features = this.vectorGeoCercaSource.getFeatures();
		var idxFeature = features.findIndex(f => f.values_.idGeocerca == data.id);
		var featureGeocerca = null;
		if (idxFeature < 0) {
			var geojsonObject = JSON.parse(data.geoJSON);
			var featureAux = (new GeoJSON()).readFeature(geojsonObject);
			featureGeocerca = new Feature({
				type: 'geocerca',
				visible: false,
				idGeocerca: data.id,
				data: data,
				geometry: featureAux.getGeometry(),
			});
			this.vectorGeoCercaSource.addFeature(featureGeocerca);
		} else {
			featureGeocerca = features[idxFeature];
		}
		return featureGeocerca;
	}

	public agregarGeoCerca() {
		this.nuevaGeoCerca = {};
		this.drawGeoCerca = new Draw({
			source: this.vectorGeoCercaSource,
			type: 'Polygon'
		});
		this.map.addInteraction(this.drawGeoCerca);
		let nap = this.snap = new Snap({
			source: this.vectorGeoCercaSource
		});
		this.map.addInteraction(nap);
		this.drawGeoCerca.on('drawstart',
			() => {
				let v = this.vectorMarcadorVehiculosLayer.getVisible();
				let nv = this.vectorMarcadorVehiculosLayer.setVisible(false);
			}
		);

		this.drawGeoCerca.on('drawend',
			resp => {
				try {
					this.nuevaGeoCerca.geoJSON = {};
					this.feature = resp.feature;
					this.geo = new GeoJSON();
					this.featureGeoJSON = this.geo.writeFeature(this.feature);
					this.nuevaGeoCerca = this.featureGeoJSON;
					this.feature.getGeometry().transform('EPSG:3857', 'EPSG:4326');
					this.geoJSON4326 = new GeoJSON();
					this.nuevaGeoCerca4326 = this.geoJSON4326.writeFeature(this.feature);
					this.vectorGeoCercaLayer.setVisible(true);
					this.map.removeInteraction(this.drawGeoCerca);
					/*Guardar GeoCerca*/
					this.guardarGeoCerca();
				} catch (e) {
					console.log(e);
					this.nuevaGeoCerca = {};
					this.map.removeInteraction(this.drawGeoCerca);
				}
			}
		);
	}

	public updateGeocerca = () => {
		let featureGeocerca: any;
		var select = new Select();
		var modify = new Modify({
			features: select.getFeatures()
		});
		var snap = new Snap({
			source: this.vectorGeoCercaSource
		});
		this.map.addInteraction(select);
		this.map.addInteraction(modify);
		this.map.addInteraction(snap);
		select.on('select', (evt) => {
			if (evt.selected.length == 1) {
				modify.on('modifyend', (evento) => {
					featureGeocerca = evento.features.getArray();
					this.geo = new GeoJSON();
					this.nuevaGeoCerca = this.geo.writeFeature(featureGeocerca[0]);
					this.geoJSON4326 = new GeoJSON();
					this.feature = featureGeocerca[0];
					this.nuevaGeoCerca4326 = this.geoJSON4326.writeFeature(this.feature, { dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857' });
					this.dataFeature = featureGeocerca[0].values_.data;
				})
			}
			if (evt.selected.length == 0) {
				this.guardarGeoCerca();
			}
		});
	}

	public guardarGeoCerca() {
		this.esGeocerca = true;
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.width = "90%";
		dialogConfig.closeOnNavigation = true;
		dialogConfig.hasBackdrop = false;
		dialogConfig.panelClass = 'custom-modalbox';
		this.dialog.open(GuardarGeocercaComponent, dialogConfig);
	}

	/**Crear Puntos de Interes */
	public puntosInteres = () => {
		var draw = new Draw({
			source: this.sourcePi,
			type: 'Point'
		});
		this.map.addInteraction(draw);
		this.map.once('click', evt => {
			let coordenadas = transform(evt.coordinate, 'EPSG:3857', 'EPSG:4326');
			this.coordenadaPI = [coordenadas[1], coordenadas[0]]

			this.iconPInteresFeature = new Feature({
				geometry: new Point(fromLonLat(evt.coordinate, 'EPSG:4326', 'EPSG:3857'))
			});
			this.iconPInteresStyle = this.getIconPInteres();
			this.iconPInteresFeature.setStyle(this.iconPInteresStyle);
			this.vectorPInteresSource.addFeature(this.iconPInteresFeature);

			/*Guardar PuntoInteres*/
			const dialogConfig = new MatDialogConfig();
			dialogConfig.autoFocus = true;
			dialogConfig.disableClose = true;
			dialogConfig.width = "30%";
			dialogConfig.closeOnNavigation = true;
			dialogConfig.hasBackdrop = false;
			dialogConfig.panelClass = 'custom-modalbox';
			const dialogRef = this.dialog.open(GuardarPuntoInteresComponent, dialogConfig);
			dialogRef.afterClosed().subscribe(() => {
				//this.vectorPInteresSource.clear();
			});
			this.map.removeInteraction(draw);
		});
	}

	public pintarPunto(data: any) {
		this.iconPInteresFeature = new Feature({
			geometry: new Point(fromLonLat(data.coordenadas, 'EPSG:4326', 'EPSG:3857'))
		});
		this.iconPInteresStyle = new Style({
			image: new Icon({
				anchor: [0.5, 0.5],
				anchorXUnits: 'fraction',
				anchorYUnits: 'fraction',
				src: data.icono
			}),
			zIndex: 10
		});
		this.iconPInteresFeature.setStyle(this.iconPInteresStyle);
		this.vectorPInteresSource.addFeature(this.iconPInteresFeature);
	}

	public getIconPInteres = () => {
		var iconStyleInicioRecorrido = new Style({
			image: new Icon({
				anchor: [0.5, 0.5],
				anchorXUnits: 'fraction',
				anchorYUnits: 'fraction',
				src: 'https://s3.amazonaws.com/gtmalfa/Markers/inicio.png'
			}),
			zIndex: 10
		});
		return iconStyleInicioRecorrido;
	}

	public verPunto(data: any) {
		this.map.getView().setCenter(transform([data.coordenadas[1], data.coordenadas[0]], 'EPSG:4326', 'EPSG:3857'));
		if (this.map.getView().getZoom() < 15) {
			this.map.getView().setZoom(60);
		}
	}

	public ocultarPuntosInteres() {
		this.vectorPInteresLayer.setVisible(false);
	}

	public mostrarPuntosInteres() {
		this.vectorPInteresLayer.setVisible(true);
	}

	/**Paso por punto */
	public pintarPasoPunto = (data: any) => {
		this.iconoPasoPuntoFeature = new Feature({
			type: 'pasopunto',
			geometry: new Point(transform(data.coordenadas, 'EPSG:4326', 'EPSG:3857'))
		});

		this.iconoPasoPuntoStyle = new Style({
			image: new Icon({
				anchor: [0.5, 0.5],
				anchorXUnits: 'fraction',
				anchorYUnits: 'fraction',
				src: './assets/media/marcadores/gtm-marker-2.png'
			}),
			zIndex: 10
		});
		this.iconoPasoPuntoFeature.setStyle(this.iconoPasoPuntoStyle);
		this.vectorPasoPuntoSource.addFeature(this.iconoPasoPuntoFeature);
		this.verPunto(data)
		this.vectorPasoPuntoLayer.setVisible(true);
	}

	abrirModalContador(alerta) {
		setTimeout(() => {
			let datos = [];
			let titulo = '';
			let icono = '';
			switch (alerta) {
				case 'rojo':
					datos = this.autosDetenidosRojo;
					titulo = 'Autos detenidos por más de 90 min';
					icono = 'fa fa-car';
					break;
				case 'verde':
					datos = this.autosMovimiento;
					titulo = 'Autos en movimiento';
					icono = 'fa fa-car';
					break;
				case 'naranja':
					datos = this.autosDetenidosNaranja;
					titulo = 'Autos detenidos por más de 60 min';
					icono = 'fa fa-car';
					break;
				case 'azul':
					datos = this.autosExcesoAzul;
					titulo = 'Autos en exceso de velocidad';
					icono = 'fa fa-car';
					break;
				case 'amarillo':
					datos = this.autosDetenidosAmarillo;
					titulo = 'Autos detenidos por más de 30 min';
					icono = 'fa fa-car';
					break;
				case 'gris':
					datos = this.autosDetenidos;
					titulo = 'Autos detenidos'
					icono = 'fa fa-car';
					break;
				default:
					break;
			}
			const dialogConfig = new MatDialogConfig();
			dialogConfig.autoFocus = true;
			dialogConfig.disableClose = true;
			dialogConfig.width = "55%";
			dialogConfig.closeOnNavigation = true;
			dialogConfig.hasBackdrop = false;
			dialogConfig.panelClass = 'custom-modalbox';
			dialogConfig.position = { right: '41.3%', top: '3.5%' };
			dialogConfig.data = [{ titulo: titulo, icono: icono, datos: datos }];
			this.dialog.open(SemaforoModalComponent, dialogConfig);
		}, 3003)

	}

	abrirModalHeader() {
		setTimeout(() => {
			let titulo = 'Salida de Geocerca';
			let icono = 'fal fa-map-marker-exclamation';
			const dialogConfig = new MatDialogConfig();
			dialogConfig.autoFocus = true;
			dialogConfig.disableClose = true;
			dialogConfig.width = "58%";
			dialogConfig.panelClass = 'custom-modalbox';
			dialogConfig.closeOnNavigation = true;
			dialogConfig.hasBackdrop = false;
			dialogConfig.position = { right: '38.2%', top: '3.4%' };
			dialogConfig.data = [{ titulo: titulo, icono: icono, datos: this.datosFueraGeocerca }];
			this.dialog.open(AlertasComponent, dialogConfig).afterClosed().subscribe(() => {
			});
		}, 3003)
	}

	/**Generales */
	//**Howen */
	validarLey(): Observable<any> {
		this.videosDisponibles.next(this.valorLey);
		return this.videosDisponibles.asObservable();
	}


	/**Abrir alertas */

	/**Mapa */
	/**Muestra popup al colocar cursor sobre algun dispositivo */
	public mouseHover() {
		this.map.on('pointermove', event => {
			let pixel = this.map.getEventPixel(event.originalEvent);
			let hit = this.map.hasFeatureAtPixel(pixel);
			if (hit) {
				document.body.style.cursor = 'pointer';
				let feature = this.map.forEachFeatureAtPixel((event.pixel),
					(feature) => {
						return feature;
					});
				let coord = feature.get('data');
				if (feature) {
					let tipo = feature.get('type');
					if (coord === undefined) {
						if (feature.get('features').length > 1) {
							let tipo = feature.get('features')[0].values_.type;
							let coordenadaFeature = feature.get('features')[0].getGeometry().getCoordinates();

							var content = `
					  <div style="color:#fff;">
					  <i style="color:#fff; margin-right:10px;" class="fal fa-bookmark"></i> <b style="color:#01a7cd;"></b>${tipo}</br>
					  <div style="color:#fff; display:block;width:100%;border-bottom: 1px solid #fff;margin-bottom:10px;"></div>

					  </div>`;
							this.contentClusterPopupHover.innerHTML = content;
							this.overlayClusterPopupHover.setPosition(coordenadaFeature);
							this.map.updateSize();

						}
					}
					if (tipo) {
						if (tipo == 'vehiculo') {
							let fecha = this.datepipe.transform(coord.fechaHoraUltimaPosicion, "yyyy-MM-dd");
							let hora = this.datepipe.transform(coord.fechaHoraUltimaPosicion, "h:mma");

							const ignicion = IGNICIONES.find(ignicion => ignicion.id == coord.ignicion);

							const lat = coord.lat;
							const lng = coord.lng;

							var content = `
                  <div style="color:#fff;">
                  <i style="color:#fff; margin-right:15px;" class="fal fa-user"></i> <b style="color:#01a7cd;">Usuario</b>: ${coord.descripcion}</br>
                  <div style="color:#fff; display:block;width:100%;border-bottom: 1px solid #fff;margin-bottom:10px;"></div>
                  <i style="color:#fff; margin-right:10px;" class="fal fa-barcode-alt"></i> <b style="color:#01a7cd;">Placa</b>: ${coord.placas}</br>
                  <i style="color:#fff; margin-right:15px;" class="fal fa-credit-card-front"></i><b style="color:#01a7cd;">Economico</b>: ${coord.economico}</br>
                  <i style="color:#fff; margin-right:11px;" class="fal fa-trademark"></i> <b style="color:#01a7cd;">Marca</b>: ${coord.marca}</br>
                  <i style="color:#fff; margin-right:13px;" class="fal fa-car"></i> <b style="color:#01a7cd;">Modelo</b>: ${coord.modelo}</br>
                  <i style="color:#fff; margin-right:17px;" class="fal fa-power-off"></i><b style="color:#01a7cd;">Ignición</b>: ${ignicion.nombre}</br>
                  <i style="color:#fff; margin-right:15px;" class="fal fa-tachometer-alt-fast"></i><b style="color:#01a7cd;">Velocidad</b>: ${coord.velocidad} Km/h</br>
                  <i style="color:#fff; margin-right:17px;" class="fal fa-clock"></i><b style="color:#01a7cd;">Fecha y Hora</b>: ${fecha} ${hora}</br>
				  <i style="color:#fff; margin-right:15px;" class="fal fa-gas-pump"></i><b style="color:#01a7cd;">Nivel de combustible</b>: ${coord.combustible} L</br>
                  <i style="color:#fff; margin-right:17px;" class="fal fa-location-arrow"></i><b style="color:#01a7cd;">Última Posición</b>: [${lat.toFixed(4)}, ${lng.toFixed(4)}]</br>

				  </div>`;
							this.contentPopupHover.innerHTML = content;
							this.overlayPopupHover.setPosition(fromLonLat([coord.lng, coord.lat]));
							this.map.updateSize();
						} else if (tipo == 'puntoInteres') {
							var content = `
                  <div style="color:#fff;">
                  <i style="color:#fff; margin-right:15px;" class="fal fa-bookmark"></i> <b style="color:#01a7cd;">Nombre</b>: ${coord.nombre}</br>
                  <div style="color:#fff; display:block;width:100%;border-bottom: 1px solid #fff;margin-bottom:10px;"></div>
                  <i style="color:#fff; margin-right:15px;" class="fal fa-file-alt"></i> <b style="color:#01a7cd;">Descripción</b>: ${coord.descripcion}</br>
                  <i style="color:#fff; margin-right:15px;" class="fal fa-location-arrow"></i><b style="color:#01a7cd;">Posición</b>: [${parseFloat(coord.coordenadas[0].toFixed(4))}, ${parseFloat(coord.coordenadas[1].toFixed(4))}]</br>
                  </div>`;
							this.contentPopupHover.innerHTML = content;
							let coordenadas = [coord.coordenadas[1], coord.coordenadas[0]]
							this.overlayPopupHover.setPosition(transform(coordenadas, 'EPSG:4326', 'EPSG:3857'));
							this.map.updateSize();
						} else if (tipo == 'pointRecorrido') {

							if (coord.tipo) {
								var content = `
                <div style="color:#fff;">
                <i style="color:#fff; margin-right:6px;" class="fal fa-barcode-alt"></i> <b style="color:#01a7cd;">IMEI</b>: ${coord.imei}</br>
                <div style="color:#fff; display:block;width:100%;border-bottom: 1px solid #fff;margin-bottom:10px;"></div>
                <i style="color:#fff; margin-right:11px;" class="fas fa-align-left"></i> <b style="color:#01a7cd;">Descripción</b>: ${coord.descripcion}</br>
                <i style="color:#fff; margin-right:6px;" class="fal fa-barcode-alt"></i> <b style="color:#01a7cd;">Económico</b>: ${coord.economico}</br>
                <i style="color:#fff; margin-right:6px;" class="fal fa-credit-card-front"></i> <b style="color:#01a7cd;">Número serie</b>: ${coord.numeroSerie}</br>
                <i style="color:#fff; margin-right:8px;" class="fas fa-power-off"></i> <b style="color:#01a7cd;">Estatus</b>: ${coord.estatus}</br>
				<i style="color:#fff; margin-right:8px;" class="fal fa-location"></i> <b style="color:#01a7cd;">GPS</b>: ${coord.gps}</br>
                <i style="color:#fff; margin-right:10px;" class="fas fa-signal-stream"></i><b style="color:#01a7cd;">Modelo</b>: ${coord.modelo}</br>
                <i style="color:#fff; margin-right:14px;" class="fal fal fa-calendar-alt"></i><b style="color:#01a7cd;">Fecha y Hora</b>: ${coord.fechaHora}</br>
                <i style="color:#fff; margin-right:13px;" class="fal fa-location-arrow"></i><b style="color:#01a7cd;">Última Posición</b>: [${coord.lat.toFixed(4)}, ${coord.lng.toFixed(4)}]</br>
                <i style="color:#fff; margin-right:14px;" class="fal fa-building"></i><b style="color:#01a7cd;">Cliente</b>: ${coord.cliente}</br>
                </div>`;

								this.contentPopupHover.innerHTML = content;
								this.overlayPopupHover.setPosition(fromLonLat([coord.lng, coord.lat]));
								this.map.updateSize();
							} else {
								var ubicacion = `[${coord.lat.toFixed(4)},${coord.lng.toFixed(4)}]`;
								var content = `
                    <div style="color:#fff;">
                    <p><i style="color:#fff;" class="fal fa-user"></i> <b style="color:#01a7cd;">Usuario</b>: <strong>${coord.descripcion}</strong></br>
                    <div style="color:#fff; display:block;width:100%;border-bottom: 1px solid #fff;margin-bottom:10px;"></div>
                    <i style="color:#fff; margin-right:10px;" class="fal fa-barcode-alt"></i> <b style="color:#01a7cd;">Placa</b>: ${coord.placas}</br>
                    <i style="color:#fff; margin-right:15px;" class="fal fa-credit-card-front"></i><b style="color:#01a7cd;">Economico</b>: ${coord.economico}</br>
                    <i style="color:#fff; margin-right:11px;" class="fal fa-trademark"></i> <b style="color:#01a7cd;">Marca</b>: ${coord.marca}</br>
                    <i style="color:#fff; margin-right:13px;" class="fal fa-car"></i> <b style="color:#01a7cd;">Modelo</b>: ${coord.modelo}</br>
                    <i style="color:#fff; margin-right:17px;" class="fal fa-power-off"></i><b style="color:#01a7cd;">Ignición</b>: ${coord.ignicion}</br>
                    <i style="color:#fff; margin-right:15px;" class="fal fa-tachometer-alt-fast"></i><b style="color:#01a7cd;">Velocidad</b>: ${coord.velocidad} Km/h</br>
                    <strong><i class="fal fa-calendar"></i> <b style="color:#01a7cd; margin-left:16px">Fecha y Hora</b>: </strong>${coord.fecha}</br>
                    <strong><i class="fal fa-location-arrow"></i> <b style="color:#01a7cd; margin-left:13px">Ubicación</b>: </strong>${ubicacion}</br>
                    </p>
                    </div>`;
								this.contentPopupHover.innerHTML = content;
								this.overlayPopupHover.setPosition(fromLonLat([coord.lng, coord.lat]));
								this.map.updateSize();

							}

						} else if (tipo == 'medidor') {

							this.medidoresService.obtenerMedidor(coord.imei).subscribe(
								(response) => {
									let fecha = this.datepipe.transform(coord.fechaAlta, "yyyy-MM-dd");
									let hora = this.datepipe.transform(coord.fechaAlta, "h:mma");

									let estatus;
									if (coord.estatus == 1) {
										estatus = 'Activo'
									} else {
										estatus = 'Inactivo'
									}

									const totalizador = response.totalizador

									const gasto = response.gasto;
									const lat = coord.lat;
									const lng = coord.lng;

									var content = `
                  <div style="color:#fff;">
                  <i style="color:#fff; margin-right:10px;" class="fal fa-barcode-alt"></i> <b style="color:#01a7cd;">IMEI</b>: ${response.imei}</br>
                  <div style="color:#fff; display:block;width:100%;border-bottom: 1px solid #fff;margin-bottom:10px;"></div>
                  <i style="color:#fff; margin-right:10px;" class="fal fa-comment-alt-lines"></i> <b style="color:#01a7cd;">Descripcion</b>: ${response.descripcion}</br>
                  <i style="color:#fff; margin-right:15px;" class="fal fa-tint"></i> <b style="color:#01a7cd;">Gasto</b>: ${gasto.toFixed(4)} m3/h</br>
                  <i style="color:#fff; margin-right:8px;" class="fal fa-hand-holding-water"></i> <b style="color:#01a7cd;">Totalizaor</b>: ${totalizador.toFixed(4)} m3</br>
                  <i style="color:#fff; margin-right:12px;" class="fal fa-toggle-on"></i><b style="color:#01a7cd;">Estatus</b>: ${estatus}</br>
                  <i style="color:#fff; margin-right:12px;" class="fal fa-weight"></i> <b style="color:#01a7cd;">Modelo</b>: ${coord.modelo}</br>
                  <i style="color:#fff; margin-right:15px;" class="fal fal fa-calendar-alt"></i><b style="color:#01a7cd;">Fecha y Hora</b>: ${fecha} ${hora}</br>
				  <i style="color:#fff; margin-right:13px;" class="fal fa-location-arrow"></i><b style="color:#01a7cd;">Última Posición</b>: [${lat.toFixed(4)}, ${lng.toFixed(4)}]</br>
                  <i style="color:#fff; margin-right:17px;" class="fal fa-building"></i><b style="color:#01a7cd;">Cliente</b>: ${coord.cliente}</br>


                  </div>`;

									this.contentPopupHover.innerHTML = content;
									this.overlayPopupHover.setPosition(fromLonLat([coord.lng, coord.lat]));
									this.map.updateSize();


								}
							)

						}
						// 			else if (tipo == 'micromedidor') {
						// 				let fechaHora = this.datepipe.transform(coord.fechaHora, "yyyy-MM-dd h:mm a");
						// 				const lat = coord.lat;
						// 				const lng = coord.lng;

						// 				var content = `
						//   <div style="color:#fff;">
						//   <i style="color:#fff; margin-right:10px;" class="fal fa-barcode-alt"></i> <b style="color:#01a7cd;">Número de serie</b>: ${coord.numeroSerie}</br>
						//   <div style="color:#fff; display:block;width:100%;border-bottom: 1px solid #fff;margin-bottom:10px;"></div>
						//   <i style="color:#fff; margin-right:10px;" class="fal fa-comment-alt-lines"></i> <b style="color:#01a7cd;">Observación</b>: ${coord.observacion}</br>
						//   <i style="color:#fff; margin-right:10px;" class="fal fa-weight"></i> <b style="color:#01a7cd;">Contador</b>: ${coord.contador} litros</br>
						//   <i style="color:#fff; margin-right:15px;" class="fal fa-tint"></i> <b style="color:#01a7cd;">Pulso</b>: ${coord.valorPulso}</br>
						//   <i style="color:#fff; margin-right:15px;" class="fal fal fa-calendar-alt"></i><b style="color:#01a7cd;">Fecha y Hora</b>: ${fechaHora}</br>
						//   <i style="color:#fff; margin-right:13px;" class="fal fa-location-arrow"></i><b style="color:#01a7cd;">Última Posición</b>: [${lat.toFixed(4)}, ${lng.toFixed(4)}]</br>

						//   </div>`;

						// 				this.contentPopupHover.innerHTML = content;
						// 				this.overlayPopupHover.setPosition(fromLonLat([coord.lng, coord.lat]));
						// 				this.map.updateSize();

						// 			} 

						/*este es la prueba del demo*/
						else if (tipo == 'micromedidor') {
							if (this._user.id === "6cac2e07-cb6d-4725-93d7-ed7ad39f5ade") {
								let fechaHora = this.datepipe.transform(coord.fechaHora, "yyyy-MM-dd h:mm a");
								const lat = 19.213896;
								const lng = -98.994782

								var content = `
							<div style="color:#fff;">
							<i style="color:#fff; margin-right:10px;" class="fal fa-barcode-alt"></i> <b style="color:#01a7cd;">Número de serie</b>: BEPYNSN</br>
							<div style="color:#fff; display:block;width:100%;border-bottom: 1px solid #fff;margin-bottom:10px;"></div>
							<i style="color:#fff; margin-right:10px;" class="fal fa-comment-alt-lines"></i> <b style="color:#01a7cd;">Descripción</b>: Este es un demo</br>
							<i style="color:#fff; margin-right:15px;" class="fal fa-tint"></i> <b style="color:#01a7cd;">Modelo</b>: Garza</br>
							<i style="color:#fff; margin-right:15px;" class="fal fal fa-calendar-alt"></i><b style="color:#01a7cd;">Fecha y Hora</b>: 4/04/2022 4:44</br>
							<i style="color:#fff; margin-right:13px;" class="fal fa-location-arrow"></i><b style="color:#01a7cd;">Última Posición</b>: [${lat.toFixed(4)}, ${lng.toFixed(4)}]</br>
			  
							</div>`;

								this.contentPopupHover.innerHTML = content;
								this.overlayPopupHover.setPosition(fromLonLat([lng, lat]));
								this.map.updateSize();
							}
							else if (tipo == 'micromedidor') {
								let fechaHora = this.datepipe.transform(coord.fechaHora, "yyyy-MM-dd h:mm a");
								const lat = coord.lat;
								const lng = coord.lng;

								var content = `
              <div style="color:#fff;">
              <i style="color:#fff; margin-right:10px;" class="fal fa-barcode-alt"></i> <b style="color:#01a7cd;">Número de serie</b>: ${coord.numeroSerie}</br>
              <div style="color:#fff; display:block;width:100%;border-bottom: 1px solid #fff;margin-bottom:10px;"></div>
			  <i style="color:#fff; margin-right:10px;" class="fal fa-comment-alt-lines"></i> <b style="color:#01a7cd;">Observación</b>: ${coord.observacion}</br>
			  <i style="color:#fff; margin-right:10px;" class="fal fa-weight"></i> <b style="color:#01a7cd;">Contador</b>: ${coord.contador} litros</br>
              <i style="color:#fff; margin-right:15px;" class="fal fa-tint"></i> <b style="color:#01a7cd;">Pulso</b>: ${coord.valorPulso}</br>
              <i style="color:#fff; margin-right:15px;" class="fal fal fa-calendar-alt"></i><b style="color:#01a7cd;">Fecha y Hora</b>: ${fechaHora}</br>
              <i style="color:#fff; margin-right:13px;" class="fal fa-location-arrow"></i><b style="color:#01a7cd;">Última Posición</b>: [${lat.toFixed(4)}, ${lng.toFixed(4)}]</br>

              </div>`;

								this.contentPopupHover.innerHTML = content;
								this.overlayPopupHover.setPosition(fromLonLat([coord.lng, coord.lat]));
								this.map.updateSize();
							}
						}
						/*este es la prueba del demo*/
						else if (tipo == 'activo') {
							let fechaHora = this.datepipe.transform(coord.fechaHora, 'yyyy-MM-dd h:mma');
							const lat = coord.lat;
							const lng = coord.lng;

							var content = `
              <div style="color:#fff;">
              <i style="color:#fff; margin-right:6px;" class="fal fa-barcode-alt"></i> <b style="color:#01a7cd;">IMEI</b>: ${coord.imei}</br>
              <div style="color:#fff; display:block;width:100%;border-bottom: 1px solid #fff;margin-bottom:10px;"></div>
              <i style="color:#fff; margin-right:11px;" class="fas fa-align-left"></i> <b style="color:#01a7cd;">Descripción</b>: ${coord.descripcion}</br>
              <i style="color:#fff; margin-right:6px;" class="fal fa-credit-card-front"></i> <b style="color:#01a7cd;">Económico</b>: ${coord.economico}</br>
              <i style="color:#fff; margin-right:6px;" class="fal fa-barcode-alt"></i> <b style="color:#01a7cd;">Número serie</b>: ${coord.numeroSerie}</br>
              <i style="color:#fff; margin-right:8px;" class="fas fa-power-off"></i> <b style="color:#01a7cd;">Estatus</b>: ${coord.estatus}</br>
			  <i style="color:#fff; margin-right:8px;" class="fal fa-location"></i> <b style="color:#01a7cd;">GPS</b>: ${coord.gps}</br>
              <i style="color:#fff; margin-right:10px;" class="fas fa-signal-stream"></i><b style="color:#01a7cd;">Modelo</b>: ${coord.modelo}</br>
              <i style="color:#fff; margin-right:14px;" class="fal fal fa-calendar-alt"></i><b style="color:#01a7cd;">Fecha y Hora</b>: ${fechaHora}</br>
              <i style="color:#fff; margin-right:13px;" class="fal fa-location-arrow"></i><b style="color:#01a7cd;">Última Posición</b>: [${lat.toFixed(4)}, ${lng.toFixed(4)}]</br>
              <i style="color:#fff; margin-right:14px;" class="fal fa-building"></i><b style="color:#01a7cd;">Cliente</b>: ${coord.cliente}</br>
              </div>`;

							this.contentPopupHover.innerHTML = content;
							this.overlayPopupHover.setPosition(fromLonLat([coord.lng, coord.lat]));
							this.map.updateSize();
						}
						else if (tipo == 'Portatiles') {
							let fechaHora = this.datepipe.transform(coord.fechaHora, 'yyyy-MM-dd h:mma');
							const lat = coord.lat;
							const lng = coord.lng;

							var content = `
				  <div style="color:#fff;">
				  <i style="color:#fff; margin-right:6px;" class="fal fa-barcode-alt"></i> <b style="color:#01a7cd;">IMEI</b>: ${coord.imei}</br>
				  <div style="color:#fff; display:block;width:100%;border-bottom: 1px solid #fff;margin-bottom:10px;"></div>
				  <i style="color:#fff; margin-right:11px;" class="fas fa-align-left"></i> <b style="color:#01a7cd;">Descripción</b>: ${coord.descripcion}</br>
				  <i style="color:#fff; margin-right:6px;" class="fal fa-credit-card-front"></i> <b style="color:#01a7cd;">Económico</b>: ${coord.economico}</br>
				  <i style="color:#fff; margin-right:6px;" class="fal fa-barcode-alt"></i> <b style="color:#01a7cd;">Número serie</b>: ${coord.numeroSerie}</br>
				  <i style="color:#fff; margin-right:8px;" class="fas fa-power-off"></i> <b style="color:#01a7cd;">Estatus</b>: ${coord.estatus}</br>
				  <i style="color:#fff; margin-right:8px;" class="fal fa-location"></i> <b style="color:#01a7cd;">GPS</b>: ${coord.gps}</br>
				  <i style="color:#fff; margin-right:10px;" class="fas fa-signal-stream"></i><b style="color:#01a7cd;">Modelo</b>: ${coord.modelo}</br>
				  <i style="color:#fff; margin-right:14px;" class="fal fal fa-calendar-alt"></i><b style="color:#01a7cd;">Fecha y Hora</b>: ${fechaHora}</br>
				  <i style="color:#fff; margin-right:13px;" class="fal fa-location-arrow"></i><b style="color:#01a7cd;">Última Posición</b>: [${lat.toFixed(4)}, ${lng.toFixed(4)}]</br>
				  <i style="color:#fff; margin-right:14px;" class="fal fa-building"></i><b style="color:#01a7cd;">Cliente</b>: ${coord.cliente}</br>
				  </div>`;

							this.contentPopupHover.innerHTML = content;
							this.overlayPopupHover.setPosition(fromLonLat([coord.lng, coord.lat]));
							this.map.updateSize();

						} else if (tipo == 'telefono') {
							let fechaHora = this.datepipe.transform(coord.fechaHora, 'yyyy-MM-dd h:mma');
							const lat = coord.lat;
							const lng = coord.lng;

							var content = `
              <div style="color:#fff;">
              <i style="color:#fff; margin-right:6px;" class="fal fa-barcode-alt"></i> <b style="color:#01a7cd;">IMEI</b>: ${coord.imei}</br>
              <div style="color:#fff; display:block;width:100%;border-bottom: 1px solid #fff;margin-bottom:10px;"></div>
              <i style="color:#fff; margin-right:11px;" class="fas fa-align-left"></i> <b style="color:#01a7cd;">Descripción</b>: ${coord.descripcion}</br>
              <i style="color:#fff; margin-right:6px;" class="fal fa-credit-card-front"></i> <b style="color:#01a7cd;">Económico</b>: ${coord.economico}</br>
              <i style="color:#fff; margin-right:6px;" class="fal fa-barcode-alt"></i> <b style="color:#01a7cd;">Número serie</b>: ${coord.numeroSerie}</br>
              <i style="color:#fff; margin-right:8px;" class="fas fa-power-off"></i> <b style="color:#01a7cd;">Estatus</b>: ${coord.estatus}</br>
              <i style="color:#fff; margin-right:10px;" class="fas fa-signal-stream"></i><b style="color:#01a7cd;">Modelo</b>: ${coord.modelo}</br>
              <i style="color:#fff; margin-right:14px;" class="fal fal fa-calendar-alt"></i><b style="color:#01a7cd;">Fecha y Hora</b>: ${fechaHora}</br>
              <i style="color:#fff; margin-right:13px;" class="fal fa-location-arrow"></i><b style="color:#01a7cd;">Última Posición</b>: [${lat.toFixed(4)}, ${lng.toFixed(4)}]</br>
              <i style="color:#fff; margin-right:14px;" class="fal fa-building"></i><b style="color:#01a7cd;">Cliente</b>: ${coord.cliente}</br>
              </div>`;

							this.contentPopupHover.innerHTML = content;
							this.overlayPopupHover.setPosition(fromLonLat([coord.lng, coord.lat]));
							this.map.updateSize();
						} else if (tipo == 'lectora') {
							const lat = coord.lat;
							const lng = coord.lng;

							var content = `
							<div style="color:#fff;">
							<i style="color:#fff; margin-right:6px;" class="fas fa-scanner"></i> <b style="color:#01a7cd;">Lector</b>: ${coord.descripcion}</br>
							<div style="color:#fff; display:block;width:100%;border-bottom: 1px solid #fff;margin-bottom:10px;"></div>
							<i style="color:#fff; margin-right:6px;" class="fal fa-barcode-alt"></i> <b style="color:#01a7cd;">Tag</b>: ${coord.odometro}</br>
							<i style="color:#fff; margin-right:6px;" class="fal fa-credit-card-front"></i> <b style="color:#01a7cd;">Económico</b>: ${coord.economico}</br>
							<i style="color:#fff; margin-right:10px;" class="fas fa-scanner-touchscreen"></i><b style="color:#01a7cd;">Modelo</b>: ${coord.modelo}</br>
							<i style="color:#fff; margin-right:10px;" class="fas fa-plug"></i><b style="color:#01a7cd;">Alimentación</b>: ${coord.alimentacion}</br>
							<i style="color:#fff; margin-right:14px;" class="fal fal fa-calendar-alt"></i><b style="color:#01a7cd;">Fecha y Hora</b>: ${coord.fechaHora}</br>
							<i style="color:#fff; margin-right:13px;" class="fal fa-location-arrow"></i><b style="color:#01a7cd;">Última Posición</b>: [${lat.toFixed(4)}, ${lng.toFixed(4)}]</br>
							</div>`;

							this.contentPopupHover.innerHTML = content;
							this.overlayPopupHover.setPosition(fromLonLat([coord.lng, coord.lat]));
							this.map.updateSize();
						}else if(tipo == 'panel'){
							const lat = coord.lat;
							const lng = coord.lng;

							var content = `
							<div style="color:#fff;">
							<i style="color:#fff; margin-right:6px;" class="fas fa-exclamation-square"></i> <b style="color:#01a7cd;">Panel</b>: ${coord.nombre}</br>
							<div style="color:#fff; display:block;width:100%;border-bottom: 1px solid #fff;margin-bottom:10px;"></div>
							<i style="color:#fff; margin-right:6px;" class="fal fa-barcode-alt"></i> <b style="color:#01a7cd;">Número serie</b>: ${coord.numeroSerie}</br>
							<i style="color:#fff; margin-right:10px;" class="fas fa-scanner-touchscreen"></i><b style="color:#01a7cd;">Modelo</b>: ${coord.modelo}</br>
							<i style="color:#fff; margin-right:13px;" class="fal fa-location-arrow"></i><b style="color:#01a7cd;">Última Posición</b>: [${lat.toFixed(4)}, ${lng.toFixed(4)}]</br>
							</div>`;

							this.contentPopupHover.innerHTML = content;
							this.overlayPopupHover.setPosition(fromLonLat([coord.lng, coord.lat]));
							this.map.updateSize();
						}
					}
				}
			} else {
				this.overlayPopupHover.setPosition(undefined);
				this.overlayClusterPopupHover.setPosition(undefined);
				document.body.style.cursor = 'default';
			}
		});
	}

	/**Abre un modal con la iformacion del dispositivo a dar click sobre el */
	public mouseClicked() {
		/*Para obtener la informacion de cualquiero producto
			api/vehiculos/informacion/id
		*/
		this.map.on('click', event => {
			let feature = this.map.forEachFeatureAtPixel((event.pixel),
				(feature) => {
					return feature;
				});
			if (feature) {
				let tipo = feature.get('type');
				if (tipo) {
					if (tipo == 'vehiculo') {
						let coord = feature.get('data');
						this.verVehiculo(coord);
						const dialogConfig = new MatDialogConfig();
						dialogConfig.autoFocus = true;
						dialogConfig.disableClose = true;
						dialogConfig.hasBackdrop = false;
						dialogConfig.width = "40%";
						dialogConfig.panelClass = 'custom-modalbox';
						dialogConfig.data = coord
						dialogConfig.position = { right: '56%', top: '3.5%' };
						this.dialog.open(InformacionVehiculoComponent, dialogConfig);
					} else if (tipo == 'puntoInteres') {
						const dialogConfig = new MatDialogConfig();
						dialogConfig.autoFocus = true;
						dialogConfig.disableClose = true;
						dialogConfig.width = "58%";
						dialogConfig.panelClass = 'custom-modalbox';
						dialogConfig.closeOnNavigation = true;
						dialogConfig.hasBackdrop = false;
						dialogConfig.position = { right: '56%', top: '3.5%' };
						//this.dialog.open(PasoPuntoComponent, dialogConfig);
					} else if (tipo == 'pointRecorrido') {
						this.dialog.closeAll();
						let idPunto = feature.get('idPosition');
						let idxRecorrido = this.posicionesReporte.findIndex(x => x.id == idPunto);
						this.indexActualRecorrido = idxRecorrido;
						this.setPosicionApuntador();
						//this.setPositionOverlayPopupRecorrido();
						this.setIconPosicionActual(idxRecorrido);
						this.centerRecorridoMap();
						this.permanentOverlayPopup();
						this.abrirPopupRecorrido();
					} else if (tipo == 'medidor') {
						const data = feature.get('data');
						const dialogConfig = new MatDialogConfig();
						dialogConfig.autoFocus = true;
						dialogConfig.disableClose = true;
						dialogConfig.hasBackdrop = false;
						dialogConfig.width = "40%";
						dialogConfig.panelClass = 'custom-modalbox';
						dialogConfig.data = data
						dialogConfig.position = { right: '56%', top: '3.5%' };
						this.dialog.open(InformacionMedidorComponent, dialogConfig);
					} else if (tipo == 'micromedidor') {
						const data = feature.get('data');
						const dialogConfig = new MatDialogConfig();
						dialogConfig.autoFocus = true;
						dialogConfig.disableClose = true;
						dialogConfig.hasBackdrop = false;
						dialogConfig.width = "40%";
						dialogConfig.panelClass = 'custom-modalbox';
						dialogConfig.data = data;
						dialogConfig.position = { right: '56%', top: '3.5%' };
						this.dialog.open(InformacionMicromedidorComponent, dialogConfig)
					} else if (tipo == 'activo') {
						const data = feature.get('data');
						this.verActivo(data);
						const dialogConfig = new MatDialogConfig();
						dialogConfig.autoFocus = true;
						dialogConfig.disableClose = true;
						dialogConfig.hasBackdrop = false;
						dialogConfig.width = '40%';
						dialogConfig.data = data;
						dialogConfig.position = { right: '56%', top: '3.5%' };
						dialogConfig.panelClass = 'custom-modalbox';
						this.dialog.open(InformacionActivoComponent, dialogConfig)
					} else if (tipo == 'telefono') {
						const data = feature.get('data');
						this.verTelefono(data)
						const dialogConfig = new MatDialogConfig();
						dialogConfig.autoFocus = true;
						dialogConfig.disableClose = true;
						dialogConfig.hasBackdrop = false;
						dialogConfig.width = '40%';
						dialogConfig.panelClass = 'custom-modalbox';
						dialogConfig.data = data;
						dialogConfig.position = { right: '56%', top: '3.5%' };
						this.dialog.open(InformacionTelefonoComponent, dialogConfig)
					} else if (tipo == 'Portatiles') {
						const data = feature.get('data');
						this.verPortatil(data);
						const dialogConfig = new MatDialogConfig();
						dialogConfig.autoFocus = true;
						dialogConfig.disableClose = true;
						dialogConfig.hasBackdrop = false;
						dialogConfig.width = '40%';
						dialogConfig.data = data;
						dialogConfig.position = { right: '56%', top: '3.5%' };
						dialogConfig.panelClass = 'custom-modalbox';
						this.dialog.open(InformacionPortatilComponent, dialogConfig)
					} else if (tipo == 'panel') {
						const data = feature.get('data');
						this.verPortatil(data);
						const dialogConfig = new MatDialogConfig();
						dialogConfig.autoFocus = true;
						dialogConfig.disableClose = true;
						dialogConfig.hasBackdrop = false;
						dialogConfig.width = '40%';
						dialogConfig.data = data;
						dialogConfig.position = { right: '56%', top: '3.5%' };
						dialogConfig.panelClass = 'custom-modalbox';
						this.dialog.open(InformacionPanelComponent, dialogConfig)
					}
				}
			} else {
				if (this.historicoMode == false) {
					if (!this.esGeocerca) {
						this.dialog.closeAll();
					}
				}
			}
		})
	}

	abrirModalmedidores() {
		setTimeout(() => {
			const dialogConfig = new MatDialogConfig();
			dialogConfig.autoFocus = true;
			dialogConfig.disableClose = true;
			dialogConfig.width = "55%";
			dialogConfig.closeOnNavigation = true;
			dialogConfig.hasBackdrop = false;
			dialogConfig.panelClass = 'custom-modalbox';
			dialogConfig.position = { right: '41.3%', top: '3.5%' };
			this.dialog.open(MedidorModalComponent, dialogConfig);
		}, 3003);

	}

	abrirModalmicromedidores() {
		setTimeout(() => {
			const dialogConfig = new MatDialogConfig();
			dialogConfig.autoFocus = true;
			dialogConfig.disableClose = true;
			dialogConfig.width = "55%";
			dialogConfig.closeOnNavigation = true;
			dialogConfig.hasBackdrop = false;
			dialogConfig.panelClass = 'custom-modalbox';
			dialogConfig.position = { right: '41.3%', top: '3.5%' };
			this.dialog.open(MicromedidorModalComponent, dialogConfig);
		}, 3003);
	}

	abrirModalactivos() {
		setTimeout(() => {
			const dialogConfig = new MatDialogConfig();
			dialogConfig.autoFocus = true;
			dialogConfig.disableClose = true;
			dialogConfig.width = "55%";
			dialogConfig.closeOnNavigation = true;
			dialogConfig.hasBackdrop = false;
			dialogConfig.panelClass = 'custom-modalbox';
			dialogConfig.position = { right: '41.3%', top: '3.5%' };
			this.dialog.open(ActivoModalComponent, dialogConfig);
		}, 3003);
	}

	abrirModalPortatiles() {
		setTimeout(() => {
			const dialogConfig = new MatDialogConfig();
			dialogConfig.autoFocus = true;
			dialogConfig.disableClose = true;
			dialogConfig.width = "55%";
			dialogConfig.closeOnNavigation = true;
			dialogConfig.hasBackdrop = false;
			dialogConfig.panelClass = 'custom-modalbox';
			dialogConfig.position = { right: '41.3%', top: '3.5%' };
			this.dialog.open(PortatilModalComponent, dialogConfig);
		}, 3003);
	}


	abrirModaltelefonos() {
		setTimeout(() => {
			const dialogConfig = new MatDialogConfig();
			dialogConfig.autoFocus = true;
			dialogConfig.disableClose = true;
			dialogConfig.width = "55%";
			dialogConfig.closeOnNavigation = true;
			dialogConfig.hasBackdrop = false;
			dialogConfig.panelClass = 'custom-modalbox';
			dialogConfig.position = { right: '41.3%', top: '3.5%' };
			this.dialog.open(TelefonoModalComponent, dialogConfig);
		}, 3003);
	}

	/**Detecta la interaccion del zoom en el mapa */
	public onZoom() {
		this.map.on('moveend', event => {
			//console.log(this.sonProductosFiltrados);
			if (this.clusterActivo) {
				if (this.map.getView().getZoom() > 12 && !this.productosVisibles) {
					/**Mostrar dispositivos y ocultar cluster */
					this.ocultarClusters();
					this.mostrarProductos();
					this.productosVisibles = true;
				} else if (this.map.getView().getZoom() < 13 && this.productosVisibles) {
					/**Muestra cluster y oculta dispositivo */
					this.ocultarProductos();
					this.mostrarClusters();
					this.productosVisibles = false;
				}
			}
		});
	}

	/**Acerca el zoom */
	public zoomCerca = () => {
		this.map.getView().setZoom(this.map.getView().getZoom() + 1);
	}

	/**Aleja el zoom */
	public zoomLejos = () => {
		this.map.getView().setZoom(this.map.getView().getZoom() - 1);
	}

	/**Centra el zoom del mapa */
	public ajustarMapa() {
		this.map.getView().setCenter(fromLonLat([this.center[0], this.center[1]]));
		this.map.updateSize();
		if (this.map.getView().getZoom() < 6.25) {
			this.map.getView().setZoom(5);
			this.map.updateSize();
		}
	}

	/**Restaura el zoom del mapa */
	public regresarMapa() {
		this.vectorDispositivoUbicadoSource.clear();
		this.vectorDispositivoUbicadoLayer.setVisible(false);
		this.map.getView().setCenter(fromLonLat([this.center[0], this.center[1]]));
		if (this.map.getView().getZoom() > 6.25) {
			this.map.getView().setZoom(5.75);
			this.map.updateSize();

			if (this.productosVisibles) {
				this.ocultarProductos();
				this.mostrarClusters();
				this.productosVisibles = false;
			}
		}
	}

	/**Recarga el mapa */
	public recargarMapa(lng, lat, zoom) {
		this.map.getView().setCenter(fromLonLat([lng, lat]));
		this.map.getView().setZoom(zoom)
	}

	/**Cierra los popups */
	public undefinedPopup() {
		this.overlayPopup.setPosition(undefined);
		//this.notVehiculo = false;
	}

	///**Capas */

	/**Este metodo se utilizara para cargar el mapa del server */
	async mapServer() {
		await this.map.removeLayer(this.googleLayer);
		if (this.clusterActivo) {
			await this.ocultarClusters();
		} else {
			if (this.activosDisponibles.length > 0)
				await this.map.removeLayer(this.vectorActivosLayer);

			if (this.lectorasDisponibles.length > 0)
				await this.map.removeLayer(this.vectorLectorasLayer);

			if (this.medidoresDisponibles.length > 0)
				await this.map.removeLayer(this.vectorMedidoresLayer);

			if (this.micromedidoresDisponibles.length > 0)
				await this.map.removeLayer(this.vectorMicromedidoresLayer);

			if (this.puntosInteresDisponibles.length > 0)
				await this.map.removeLayer(this.vectorPInteresLayer);

			if (this.telefonosDisponibles.length > 0)
				await this.map.removeLayer(this.vectorTelefonosLayer);

			if (this.vehiculosDisponibles.length > 0)
				await this.map.removeLayer(this.vectorMarcadorVehiculosLayer);
			if (this.portatilesDisponibles.length > 0)
				await this.map.removeLayer(this.vectorPortatilesLayer);
		}
		await this.map.getLayers().push(new TileLayer({
			source: new TileWMS({
				url: 'http://192.168.6.102:444/cgi-bin/mapserv.exe?map=C:/ms4w/Apache/htdocs/Mapfiles/wms.map',
				crossOrigin: 'anonymous',
				params: { 'LAYERS': 'wms', 'VERSION': '1.1.1' },
				serverType: 'mapserver',
				projection: 'EPSG:4326',
				transition: 2
			}),
		}));
		if (this.clusterActivo) {
			await this.mostrarClusters();
		} else {
			if (this.activosDisponibles.length > 0)
				await this.map.addLayer(this.vectorActivosLayer);

			if (this.lectorasDisponibles.length > 0)
				await this.map.addLayer(this.vectorLectorasLayer);

			if (this.medidoresDisponibles.length > 0)
				await this.map.addLayer(this.vectorMedidoresLayer);

			if (this.micromedidoresDisponibles.length > 0)
				await this.map.addLayer(this.vectorMicromedidoresLayer);

			if (this.puntosInteresDisponibles.length > 0)
				await this.map.addLayer(this.vectorPInteresLayer);

			if (this.telefonosDisponibles.length > 0)
				await this.map.addLayer(this.vectorTelefonosLayer);

			if (this.vehiculosDisponibles.length > 0)
				await this.map.addLayer(this.vectorMarcadorVehiculosLayer);

			if (this.portatilesDisponibles.length > 0)
				await this.map.addLayer(this.vectorPortatilesLayer);
		}
	}

	public roadmap() {
		/*this.map.getLayers().push(new GoogleLayer({
			mapTypeId: 'roadmap'
		}));*/
		this.map.removeLayer(this.googleLayer);

		this.googleLayer = new GoogleLayer({
			mapTypeId: 'roadmap'
		})
		this.map.getLayers().push(this.googleLayer);
	}

	public satellite() {
		this.map.removeLayer(this.googleLayer);

		this.googleLayer = new GoogleLayer({
			mapTypeId: 'satellite'
		})
		this.map.getLayers().push(this.googleLayer);
	}

	public hybrid() {
		this.map.removeLayer(this.googleLayer);

		this.googleLayer = new GoogleLayer({
			mapTypeId: 'hybrid'
		})
		this.map.getLayers().push(this.googleLayer);
	}

	public terrain() {
		this.map.removeLayer(this.googleLayer);

		this.googleLayer = new GoogleLayer({
			mapTypeId: 'terrain'
		})
		this.map.getLayers().push(this.googleLayer);
	}

	public traffic() {
		const gmap = this.olGM.getGoogleMapsMap();
		if (this.trafficLayer.getMap() == null) {
			this.trafficLayer.setMap(gmap);
		}
		else {
			this.trafficLayer.setMap(null);
		}
	}

	public transit() {
		const gmap = this.olGM.getGoogleMapsMap();
		if (this.transitLayer.getMap() == null) {
			this.transitLayer.setMap(gmap);
		}
		else {
			this.transitLayer.setMap(null);
		}
	}

	public bicycling() {
		const gmap = this.olGM.getGoogleMapsMap();
		if (this.bicyclingLayer.getMap() == null) {
			this.bicyclingLayer.setMap(gmap);
		}
		else {
			this.bicyclingLayer.setMap(null);
		}
	}

	///**Para siempre */
	public mostrarParaSiempre() {
		this.mostrarEtiquetasActivos();
		this.mostrarEtiquetasMedidores();
		this.mostrarEtiquetasMicromedidores();
		this.mostrarEtiquetasTelefonos();
		this.mostrarEtiquetasVehiculos();
		this.mostrarEtiquetasPortatiles();
	}

	public ocultarParaSiempre() {
		this.ocultarEtiquetasActivos();
		this.ocultarEtiquetasMedidores();
		this.ocultarEtiquetasMicromedidores();
		this.ocultarEtiquetasTelefonos();
		this.ocultarEtiquetasVehiculos();
		this.ocultarEtiquetasPortatiles();
	}



	/*ocultarEtiquetasPaneles() {
		this.etiquetasPanels.forEach(idName => {
			let etiquetas = <HTMLElement>document.getElementById(`${idName}`);
			if (etiquetas !== null) {
				etiquetas.hidden = true;
			}
		});
	}
*/

	ocultarEtiquetasActivos() {
		this.etiquetasActivos.forEach(idName => {
			let etiquetas = <HTMLElement>document.getElementById(`${idName}`);
			if (etiquetas !== null) {
				etiquetas.hidden = true;
			}
		});
	}

	mostrarEtiquetasActivos() {
		this.etiquetasActivos.forEach(idName => {
			let etiquetas = <HTMLElement>document.getElementById(`${idName}`);
			if (etiquetas !== null) {
				etiquetas.hidden = false;
			}
		});
	}

	ocultarEtiquetasPortatiles() {
		this.etiquetasPortatiles.forEach(idName => {
			let etiquetas = <HTMLElement>document.getElementById(`${idName}`);
			if (etiquetas !== null) {
				etiquetas.hidden = true;
			}
		});
	}

	mostrarEtiquetasPortatiles() {
		this.etiquetasPortatiles.forEach(idName => {
			let etiquetas = <HTMLElement>document.getElementById(`${idName}`);
			if (etiquetas !== null) {
				etiquetas.hidden = false;
			}
		});
	}

	ocultarEtiquetasMedidores() {
		this.etiquetasMedidores.forEach(idName => {
			let etiquetas = <HTMLElement>document.getElementById(`${idName}`);
			if (etiquetas !== null) {
				etiquetas.hidden = true;
			}
		});
	}


	mostrarEtiquetasMedidores() {
		this.etiquetasMedidores.forEach(idName => {
			let etiquetas = <HTMLElement>document.getElementById(`${idName}`);
			if (etiquetas !== null) {
				etiquetas.hidden = false;
			}
		});
	}

	ocultarEtiquetasMicromedidores() {
		this.etiquetasMicromedidores.forEach(idName => {
			let etiquetas = <HTMLElement>document.getElementById(`${idName}`);
			if (etiquetas !== null) {
				etiquetas.hidden = true;
			}
		});
	}

	mostrarEtiquetasMicromedidores() {
		this.etiquetasMicromedidores.forEach(idName => {
			let etiquetas = <HTMLElement>document.getElementById(`${idName}`);
			if (etiquetas !== null) {
				etiquetas.hidden = false;
			}
		});
	}

	ocultarEtiquetasTelefonos() {
		this.etiquetasTelefonos.forEach(idName => {
			let etiquetas = <HTMLElement>document.getElementById(`${idName}`);
			if (etiquetas !== null) {
				etiquetas.hidden = true;
			}
		});
	}

	mostrarEtiquetasTelefonos() {
		this.etiquetasTelefonos.forEach(idName => {
			let etiquetas = <HTMLElement>document.getElementById(`${idName}`);
			if (etiquetas !== null) {
				etiquetas.hidden = false;
			}
		});
	}

	ocultarEtiquetasVehiculos() {
		this.etiquetasVehiculos.forEach(idName => {
			let etiquetas = <HTMLElement>document.getElementById(`${idName}`);
			if (etiquetas !== null) {
				etiquetas.hidden = true;
			}
		});
	}

	mostrarEtiquetasVehiculos() {
		this.etiquetasVehiculos.forEach(idName => {
			let etiquetas = <HTMLElement>document.getElementById(`${idName}`);
			if (etiquetas !== null) {
				etiquetas.hidden = false;
			}
		});
	}

	public mostrarApuntadorSeleccionado(data) {/**Pinta spinar al dar click a algun producto en el mapa? */
		var pos = fromLonLat([data.lng, data.lat]);
		this.iconApuntadorSelectFeature = new Feature({
			type: 'puntoApuntadorSelect',
			geometry: new Point(pos)
		});
		this.iconSelectApuntador = new Style({
			image: new Icon({
				anchor: [0.5, 0.5],
				anchorXUnits: 'fraction',
				anchorYUnits: 'fraction',
				src: this.iconosPng.colorApuntador(data.estado)
			}),
			zIndex: 10
		});
		this.iconApuntadorSelectFeature.setStyle(this.iconSelectApuntador);
		this.vectorApuntadorSource.addFeature(this.iconApuntadorSelectFeature);
		this.vectorApuntadorSelectLayer.setVisible(true);
	}

	///**Apuntadores */
	public verActivo(data: ActivoUltimaTransmision) {
		this.apuntadorDispositivo(data);
		this.map.getView().setCenter(fromLonLat([data.lng, data.lat]));
		if (this.map.getView().getZoom() < 15) {
			this.map.getView().setZoom(20);
		}
	}

	public verPortatil(data: PortatilUltimaTransmision) {
		this.apuntadorDispositivo(data);
		this.map.getView().setCenter(fromLonLat([data.lng, data.lat]));
		if (this.map.getView().getZoom() < 15) {
			this.map.getView().setZoom(20);
		}
	}

	public verMedidor(data: Medidores) {
		this.apuntadorHidraulicos(data);
		this.map.getView().setCenter(fromLonLat([data.lng, data.lat]));
		if (this.map.getView().getZoom() < 15) {
			this.map.getView().setZoom(20);
		}
	}

	/*prueba del demo*/
	public verMedidorDemo(data: Medidores) {
		this._user = this.auth.getUser();
		if (this._user.id === "6cac2e07-cb6d-4725-93d7-ed7ad39f5ade") {
			const lat = 19.213896;
			const lng = -98.994782
			this.apuntadorHidraulicosDemo(data);
			this.map.getView().setCenter(fromLonLat([lng, lat]));
			if (this.map.getView().getZoom() < 15) {
				this.map.getView().setZoom(20);
			}
		}
	}
	/*prueba del demo*/

	public verTelefono(data: TelefonoUltimaTransmision) {
		this.apuntadorTelefono(data);
		this.map.getView().setCenter(fromLonLat([data.lng, data.lat]));
		if (this.map.getView().getZoom() < 15) {
			this.map.getView().setZoom(60);

		}
	}

	public apuntadorTelefono(coord) {
		this.vectorDispositivoUbicadoSource.clear();
		this.vectorDispositivoUbicadoLayer.setVisible(false);

		var pos = fromLonLat([coord.lng, coord.lat]);
		let coordenadas: Params = { lng: Number(coord.lng.toFixed(5)), lat: Number(coord.lat.toFixed(5)), zoom: 28 }
		this.auth.setStorageCoordinate(coordenadas);

		var dispositivoFeature = new Feature({
			type: 'puntoApuntadorAlerta',
			geometry: new Point(pos)
		});
		var iconStyleApuntador = new Style({
			image: new Icon({
				anchor: [0.5, 0.5],
				anchorXUnits: 'fraction',
				anchorYUnits: 'fraction',
				src: this.iconosPng.colorApuntador(coord)
			}),
			zIndex: 10
		});
		dispositivoFeature.setStyle(iconStyleApuntador);
		this.vectorDispositivoUbicadoSource.addFeature(dispositivoFeature);
		this.vectorDispositivoUbicadoLayer.setVisible(true);
	}

	public verVehiculo(data: Autos) {
		this.apuntadorDispositivo(data);
		this.map.getView().setCenter(fromLonLat([data.lng, data.lat]));
		if (this.map.getView().getZoom() < 15) {
			this.map.getView().setZoom(20);

		}
	}



	public apuntadorHidraulicos(coord) {
		this.vectorDispositivoUbicadoSource.clear();
		this.vectorDispositivoUbicadoLayer.setVisible(false);
		let coordenadas: Params = { lng: Number(coord.lng.toFixed(5)), lat: Number(coord.lat.toFixed(5)), zoom: 28 }
		this.auth.setStorageCoordinate(coordenadas);
		var pos = fromLonLat([coord.lng, coord.lat]);
		var dispositivoFeature = new Feature({
			type: 'puntoApuntadorAlerta',
			geometry: new Point(pos)
		});
		var iconStyleApuntador = new Style({
			image: new Icon({
				anchor: [0.5, 0.5],
				anchorXUnits: 'fraction',
				anchorYUnits: 'fraction',
				src: './assets/media/puntos/spinnerAzul.png',
			}),
			zIndex: 10
		});
		dispositivoFeature.setStyle(iconStyleApuntador);
		this.vectorDispositivoUbicadoSource.addFeature(dispositivoFeature);
		this.vectorDispositivoUbicadoLayer.setVisible(true);
	}

	/*prueba del demo*/
	public apuntadorHidraulicosDemo(coord) {
		const lat = 19.213896;
		const lng = -98.994782
		this.vectorDispositivoUbicadoSource.clear();
		this.vectorDispositivoUbicadoLayer.setVisible(false);
		let coordenadas: Params = { lng: Number(lng.toFixed(5)), lat: Number(lat.toFixed(5)), zoom: 28 }
		this.auth.setStorageCoordinate(coordenadas);
		var pos = fromLonLat([lng, lat]);
		var dispositivoFeature = new Feature({
			type: 'puntoApuntadorAlerta',
			geometry: new Point(pos)
		});
		var iconStyleApuntador = new Style({
			image: new Icon({
				anchor: [0.5, 0.5],
				anchorXUnits: 'fraction',
				anchorYUnits: 'fraction',
				src: './assets/media/puntos/spinnerAzul.png',
			}),
			zIndex: 10
		});
		dispositivoFeature.setStyle(iconStyleApuntador);
		this.vectorDispositivoUbicadoSource.addFeature(dispositivoFeature);
		this.vectorDispositivoUbicadoLayer.setVisible(true);
	}
	/*prueba del demo*/

	public apuntadorDispositivo(coord) {
		this.vectorDispositivoUbicadoSource.clear();
		this.vectorDispositivoUbicadoLayer.setVisible(false);

		let coordenadas: Params = { lng: Number(coord.lng.toFixed(5)), lat: Number(coord.lat.toFixed(5)), zoom: 28 }
		this.auth.setStorageCoordinate(coordenadas);
		var pos = fromLonLat([coord.lng, coord.lat]);
		var dispositivoFeature = new Feature({
			type: 'puntoApuntadorAlerta',
			geometry: new Point(pos)
		});
		var iconStyleApuntador = new Style({
			image: new Icon({
				anchor: [0.5, 0.5],
				anchorXUnits: 'fraction',
				anchorYUnits: 'fraction',
				src: this.colorApuntador(coord.estado),
			}),
			zIndex: 10
		});
		dispositivoFeature.setStyle(iconStyleApuntador);
		this.vectorDispositivoUbicadoSource.addFeature(dispositivoFeature);
		this.vectorDispositivoUbicadoLayer.setVisible(true);
	}

	public ubicarProducto(lng: Number, lat: Number) {
		lng = Number(lng);
		lat = Number(lat)
		const DATA = { lng: lng, lat: lat };
		this.apuntadorDispositivo(DATA);
		this.map.getView().setCenter(fromLonLat([lng, lat]));
		if (this.map.getView().getZoom() < 15) {
			this.map.getView().setZoom(20);
		}
	}

	ocultarUbicadorLayer() {
		this.vectorDispositivoUbicadoSource.clear();
		this.vectorDispositivoUbicadoLayer.setVisible(false);

	}

	ocultarUbicadorPanelesLayer() {
		this.vectorDispositivoUbicadoSource.clear();
		this.vectorDispositivoUbicadoLayer.setVisible(false);

	}

	abrirPopupRecorrido() {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.width = "20%";
		dialogConfig.panelClass = 'custom-modalbox';
		dialogConfig.position = { right: '76%', top: '3.5%' };
		dialogConfig.closeOnNavigation = true;
		dialogConfig.hasBackdrop = false;
		this.dialog.open(PopupRecorridoHistoricoComponent, dialogConfig);
	}

	///**Historico */
	public pintarMarcadoresHistorico = () => {
		this.historicoMode = true;
		document.getElementById('style-7').classList.add('menu-barHidde');
		document.getElementById('map-content').classList.add('map-recorrido');
		if (this.posicionesReporte.length) {
			this.ocultarTelefonos();
			this.ocultarVehiculos();
			this.ocultarActivos();
			this.ocultarApuntadorAlertas();
			this.ocultarParaSiempre();
			this.ocultarMedidores();
			this.ocultarMicromedidores();
			this.ocultarPuntosInteres();
			this.ocultarLectoras();
			this.ocultarPortatiles();
			this.vectorDispositivoUbicadoLayer.setVisible(false);
			this.dibujarRecorrido();
		} else {
			this.toastr.error('No se encontraron posiciones en el rango de tiempo especificado', '');
		}
	}

	public dibujarRecorrido = () => {
		this.vectorHistoricoSource.clear();
		var longitud = this.posicionesReporte.length;

		var coordenadas = [];
		this.posicionesReporte.forEach((posicion, key) => {
			var pointPosicion = new Feature({
				id: posicion.id,
				type: 'pointRecorrido',
				idPosition: posicion.id,
				data: posicion,
				geometry: new Point(fromLonLat([posicion.lng, posicion.lat])),
			});

			//pointPosicion.setId(posicion.id);
			let iconStylePoint = null;

			if (key == 0) {
				iconStylePoint = this.getIconInicioRecorrido(posicion.icono, posicion.direccion);
				this.posicionActualRecorrido = posicion;
			} else if (key == (longitud - 1)) {
				iconStylePoint = this.getIconFinalRecorrido(posicion.icono, posicion.direccion);
			} else {
				let inicio = [posicion.lng, posicion.lat];
				let final = [this.posicionesReporte[key + 1].lng, this.posicionesReporte[key + 1].lat];
				iconStylePoint = this.getIconPointPosicion(inicio, final, posicion.icono);
			}


			pointPosicion.setStyle(iconStylePoint);
			this.vectorHistoricoSource.addFeature(pointPosicion);
			coordenadas.push(fromLonLat([posicion.lng, posicion.lat]));
		});

		var lineas = new Feature({
			type: 'lineRecorrido',
			geometry: new LineString(coordenadas),
		});

		var lineStyle = new Style({
			stroke: new Stroke({
				color: '#CC0000',
				width: 4,
				lineDash: [10, 20]

			})
		});

		lineas.setStyle(lineStyle);
		this.vectorHistoricoSource.addFeature(lineas);
		this.indexActualRecorrido = 0;
		this.indexFinalRecorrido = longitud - 1;
		this.mostrarLayerRecorrido();
		this.mostrarApuntador();
		this.setPosicionApuntador();
		//this.setPositionOverlayPopupRecorrido();
		this.permanentOverlayPopup();
		this.centerMapHistorico();
		this.mostrandoRecorrido = true;
	}

	public setPosicionApuntador() { /**Coloca el spinner */
		var currentPosition = this.posicionesReporte[this.indexActualRecorrido];
		var pos = fromLonLat([currentPosition.lng, currentPosition.lat]);
		this.iconApuntador = new Style({
			image: new Icon({
				anchor: [0.5, 0.5],
				anchorXUnits: 'fraction',
				anchorYUnits: 'fraction',
				src: this.iconosPng.colorApuntador(currentPosition)
			}),
			zIndex: 10
		});
		this.iconApuntadorFeature.setStyle(this.iconApuntador);
		this.iconApuntadorFeature.getGeometry().setCoordinates(pos);
	}

	public centerRecorridoMap() {
		var posicionActual = this.posicionesReporte[this.indexActualRecorrido];
		this.map.getView().setCenter(fromLonLat([posicionActual.lng, posicionActual.lat]));
		if (this.map.getView().getZoom() < 17) {
			this.map.getView().setZoom(17);
		}
	}

	public centerMapHistorico() {
		var posicionActual = this.posicionesReporte[this.indexActualRecorrido];
		this.map.getView().setCenter(fromLonLat([posicionActual.lng, posicionActual.lat]));
		if (this.map.getView().getZoom() < 17) {
			this.map.getView().setZoom(12);
		}
	}

	public getIconInicioRecorrido(icono, dir) {
		var iconStyleInicioRecorrido = new Style({
			image: new Icon({
				anchor: [0.5, 0.5],
				anchorXUnits: 'fraction',
				anchorYUnits: 'fraction',
				rotation: -dir,
				src: icono
			}),
			zIndex: 10
		});
		return iconStyleInicioRecorrido;
	}

	public irSiguiente() {
		var indexPrevio = this.indexActualRecorrido;
		this.indexActualRecorrido = this.indexActualRecorrido + 1;
		if (this.indexActualRecorrido > this.indexFinalRecorrido) {
			this.indexActualRecorrido = 0;
		}

		this.setPosicionApuntador();
		//this.setPositionOverlayPopupRecorrido();
		this.permanentOverlayPopup();
		this.setIconPosicionActual(indexPrevio);
		this.centerRecorridoMap();
	}

	public irAnterior() {
		var indexPrevio = this.indexActualRecorrido;
		this.indexActualRecorrido = this.indexActualRecorrido - 1;
		if (this.indexActualRecorrido < 0) {
			this.indexActualRecorrido = this.indexFinalRecorrido;
		}

		this.setPosicionApuntador();
		//this.setPositionOverlayPopupRecorrido();
		this.permanentOverlayPopup();
		this.setIconPosicionActual(indexPrevio);
		this.centerRecorridoMap();

	}

	public irInicioRecorrido() {
		var indexPrevio = this.indexActualRecorrido;
		this.indexActualRecorrido = 0;
		this.setPosicionApuntador();
		//this.setPositionOverlayPopupRecorrido();
		this.permanentOverlayPopup();
		this.setIconPosicionActual(indexPrevio);
		this.centerRecorridoMap();
	}

	public irFinalRecorrido() {
		var indexPrevio = this.indexActualRecorrido;
		this.indexActualRecorrido = this.indexFinalRecorrido;
		this.setPosicionApuntador();
		//this.setPositionOverlayPopupRecorrido();
		this.permanentOverlayPopup();
		this.setIconPosicionActual(indexPrevio);
		this.centerRecorridoMap();

	}

	public getIconFinalRecorrido(icono, dir) {
		var iconStyleFinalRecorrido = new Style({
			image: new Icon({
				anchor: [0.5, 0.5],
				anchorXUnits: 'fraction',
				anchorYUnits: 'fraction',
				rotation: -dir,
				src: icono
			}),
			zIndex: 10
		});
		return iconStyleFinalRecorrido;
	}

	public getIconPointPosicion(inicio, final, icono) {
		var dx = final[0] - inicio[0];
		var dy = final[1] - inicio[1];
		var rotation = Math.atan2(dy, dx);

		var iconStylePoint = new Style({
			image: new Icon({
				anchor: [0.5, 0.5],
				anchorXUnits: 'fraction',
				anchorYUnits: 'fraction',
				rotateWithView: true,
				rotation: -rotation,
				src: icono
			}),
			zIndex: 0,
		});
		return iconStylePoint;
	};

	public setIconPosicionActual(indexPrevio) {
		var posicion = this.posicionesReporte[this.indexActualRecorrido];
		var posicionPrevia = this.posicionesReporte[indexPrevio];

		var features = this.vectorHistoricoSource.getFeatures();
		var idxFeature = features.findIndex(f => f.values_.type == 'pointRecorrido' && f.values_.idPosition == posicion.id);
		var idxFeaturePrevio = features.findIndex(f => f.values_.type == 'pointRecorrido' && f.values_.idPosition == posicionPrevia.id);

		var featureActual = features[idxFeature];
		var featurePrevio = features[idxFeaturePrevio];

		featurePrevio.getStyle().setZIndex(0);
		featureActual.getStyle().setZIndex(1);
	}

	permanentOverlayPopup(): Observable<any> { /**Obtiene la informacion para el modal permanente */
		let longitud = this.posicionesReporte.length;
		let numeroActual = this.indexActualRecorrido + 1;
		let posicionInfo = this.posicionesReporte[this.indexActualRecorrido];
		this.ubicacionHistorico = { lat: posicionInfo.lat, lng: posicionInfo.lng }
		let tipo: string;
		if (posicionInfo.tipo) {
			tipo = this.tipoProducto;
		} else {
			tipo = 'vehiculo';
		}

		let informacion = {
			longitud: longitud,
			numeroActual: numeroActual,
			datos: posicionInfo,
			tipo: tipo
		}

		this.informacionInicial = informacion;
		this.informacionRecorrio.next(informacion);
		return this.informacionRecorrio.asObservable();
	}

	historicoStreetView() {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.panelClass = 'custom-modalbox';
		dialogConfig.width = "45%";
		dialogConfig.closeOnNavigation = true;
		dialogConfig.hasBackdrop = false;
		dialogConfig.data = this.ubicacionHistorico;
		this.dialog.open(StreetViewComponent, dialogConfig);
	}

	validarEstadoHistorico(): Observable<any> {/**Valida si el mapa esta en modo historico o no*/
		this.modoHistorico.next(this.estadoHistorico);
		return this.modoHistorico.asObservable();
	}

	public ubicarPuntoHistorico(coord) {
		this.map.getView().setCenter(fromLonLat([coord.lng, coord.lat]));
		if (this.map.getView().getZoom() < 19) {
			this.map.getView().setZoom(19);
		}
		var pos = fromLonLat([coord.lng, coord.lat]);
		this.iconApuntador = new Style({
			image: new Icon({
				anchor: [0.5, 0.5],
				anchorXUnits: 'fraction',
				anchorYUnits: 'fraction',
				src: this.iconosPng.colorApuntador(coord)
			}),
			zIndex: 10
		});
		this.iconApuntadorFeature.setStyle(this.iconApuntador);
		this.iconApuntadorFeature.getGeometry().setCoordinates(pos);
	}

	public cerrarRecorrido() { /**Cirra el recorrido */
		this.mostrandoRecorrido = false;
		this.mostrarVehiculos();
		this.mostrarApuntadorAlertas();
		//this.mostrarPuntosInteres();
		this.mostrarMedidores();
		this.mostrarActivos();
		this.mostrarTelefonos();
		this.mostrarPortatiles();
		this.ocultarLayerRecorrido();
		this.posicionesReporte = [];
		this.indexActualRecorrido = 0;
		this.indexFinalRecorrido = 0;
		this.overlayPopup.setPosition(undefined);
		this.dialog.closeAll();
		this.informacionRecorrio.complete();
		this.vectorApuntadorLayer.setVisible(false);
		this.valorLey = false;
		this.estadoHistorico = false;
		if (this.pintarEtiquetas) {
			this.mostrarParaSiempre();
		}
	}

	public mostrarApuntador() { /**Pinta el spinner en la posicion seleccionada */
		var currentPosition = this.posicionesReporte[this.indexActualRecorrido];

		var pos = fromLonLat([currentPosition.lng, currentPosition.lat]);
		this.iconApuntadorFeature = new Feature({
			type: 'puntoApuntador',
			geometry: new Point(pos)
		});
		this.iconApuntador = new Style({
			image: new Icon({
				anchor: [0.5, 0.5],
				anchorXUnits: 'fraction',
				anchorYUnits: 'fraction',
				src: this.iconosPng.colorApuntador(currentPosition)
			}),
			zIndex: 10
		});
		this.iconApuntadorFeature.setStyle(this.iconApuntador);
		this.vectorApuntadorSource.addFeature(this.iconApuntadorFeature);
		//this.vectorApuntadorLayer.setVisible(true);
	}

	public mostrarLayerRecorrido() { /**Pinta el recorrido */
		this.vectorHistoricoLayer.setVisible(true);
		//this.vectorApuntadorLayer.setVisible(true);
	}

	public ocultarLayerRecorrido() { /**Oculte el recorrido */
		this.vectorHistoricoLayer.setVisible(false);
	}

	///**StreetView */
	abrirStreetView = () => {
		this.drawPoint = new Draw({
			source: this.sourcePi,
			type: 'Point',
			image: new Style({
				radius: 7,
				fill: new Fill({
					color: 'red'
				})
			})

		});

		this.map.addInteraction(this.drawPoint);
		this.map.once('click', evt => {
			const coordenadaPI = transform(evt.coordinate, 'EPSG:3857', 'EPSG:4326');

			/*Guardar PuntoInteres*/
			const dialogConfig = new MatDialogConfig();
			dialogConfig.autoFocus = true;
			dialogConfig.disableClose = true;
			dialogConfig.panelClass = 'custom-modalbox';
			dialogConfig.width = "45%";
			dialogConfig.closeOnNavigation = true;
			dialogConfig.hasBackdrop = false;
			dialogConfig.data = { lat: coordenadaPI[1], lng: coordenadaPI[0] }
			this.dialog.open(StreetViewComponent, dialogConfig);
			this.map.removeInteraction(this.drawPoint);
		});
	}

	limpiarMapa() {
		this.ocultarClusters();
		this.ocultarParaSiempre()
		this.vectorActivosSource.clear();
		this.vectorLectorasSource.clear();
		this.vectorMedidoresSource.clear();
		this.vectorMicromedidoresSource.clear();
		//this.vectorPInteresSource.clear();
		this.vectorTelefonosSource.clear();
		this.vectorMarcadorVehiculosSource.clear();
		this.vectorDispositivoUbicadoLayer.setVisible(false);
		this.vectorApuntadorAlertaSource.clear();
		this.vectorPortatilesSource.clear();
		this.vectorPanelesSource.clear();
		//this.ocultarApuntadorAlertas()

		this.etiquetasActivos = [];
		this.etiquetasLectoras = [];
		this.etiquetasMedidores = [];
		this.etiquetasMicromedidores = [];
		this.etiquetasTelefonos = [];
		this.etiquetasVehiculos = [];
		this.etiquetasPortatiles = [];
		this.etiquetasPaneles = [];
		this.limpiarDispositivos();

	}

	//**Toogle */
	toogleCapaActivos() {
		if (this.vectorActivosLayer.getVisible()) {
			this.ocultarActivos();
			this.toogleActivos = false;
		} else {
			this.mostrarActivos();
			this.toogleActivos = true;
		}
	}

	toogleCapaPortatiles() {
		if (this.vectorPortatilesLayer.getVisible()) {
			this.ocultarPortatiles();
			this.tooglePortatiles = false;
		} else {
			this.mostrarPortatiles();
			this.tooglePortatiles = true;
		}
	}

	toogleCapaMedidores() {
		if (this.vectorMedidoresLayer.getVisible()) {
			this.ocultarMedidores();
			this.toogleMedidores = false;
		} else {
			this.mostrarMedidores();
			this.toogleMedidores = true;
		}
	}

	toogleCapaMicromedidores() {
		if (this.vectorMicromedidoresLayer.getVisible()) {
			this.ocultarMicromedidores();
			this.toogleMicromedidores = false;
		} else {
			this.mostrarMicromedidores();
			this.toogleMicromedidores = true;

		}
	}

	toogleCapaTelefonos() {
		if (this.vectorTelefonosLayer.getVisible()) {
			this.ocultarTelefonos();
			this.toogleTelefonos = false;
		} else {
			this.mostrarTelefonos();
			this.toogleTelefonos = true;
		}
	}

	toogleCapaVehiculos() {
		if (this.vectorMarcadorVehiculosLayer.getVisible()) {
			this.ocultarVehiculos()
			this.vectorApuntadorAlertaLayer.setVisible(false);
			this.toogleVehiculos = false;
		} else {
			this.mostrarVehiculos();
			this.vectorApuntadorAlertaLayer.setVisible(true);
			this.toogleVehiculos = true;
		}
	}
	toogleCapaCluster() {
		if (this.clusterActivo) {
			this.ocultarClusters();
			this.mostrarProductos();
			this.clusterActivo = false;
			this.productosVisibles = true;

		} else {
			this.ocultarProductos();
			this.mostrarClusters();
			this.clusterActivo = true;
			this.productosVisibles = false;
		}
	}

	ocultarClusters() {
		this.map.removeLayer(this.vectorClusterActivosLayer);
		this.map.removeLayer(this.vectorClusterLectorasLayer);
		this.map.removeLayer(this.vectorClusterMedidoresLayer);
		this.map.removeLayer(this.vectorClusterMicromedidoresLayer);
		this.map.removeLayer(this.vectorClusterPuntosInteresLayer);
		this.map.removeLayer(this.vectorClusterTelefonosLayer);
		this.map.removeLayer(this.vectorClusterVehiculosLayer);
		this.map.removeLayer(this.vectorClusterPortatilesLayer);
	}

	ocultarClusterActivo() {
		this.map.removeLayer(this.vectorClusterActivosLayer);
	}

	ocultarClusterLectoras() {
		this.map.removeLayer(this.vectorClusterLectorasLayer);
	}

	ocultarClusterMedidores() {
		this.map.removeLayer(this.vectorClusterMedidoresLayer);
	}

	ocultarClusterMicromedidores() {
		this.map.removeLayer(this.vectorClusterMicromedidoresLayer);
	}

	ocultarClusterPuntos() {
		this.map.removeLayer(this.vectorClusterPuntosInteresLayer);
	}

	ocultarClusterTelefonos() {
		this.map.removeLayer(this.vectorClusterTelefonosLayer);
	}

	ocultarClusterVehiculos() {
		this.map.removeLayer(this.vectorClusterVehiculosLayer);
	}

	mostrarClusters() {
		if (this.activosDisponibles.length > 0)
			this.map.addLayer(this.vectorClusterActivosLayer);

		if (this.lectorasDisponibles.length > 0)
			this.map.addLayer(this.vectorClusterLectorasLayer);

		if (this.medidoresDisponibles.length > 0)
			this.map.addLayer(this.vectorClusterMedidoresLayer);

		if (this.micromedidoresDisponibles.length > 0)
			this.map.addLayer(this.vectorClusterMicromedidoresLayer);

		if (this.puntosInteresDisponibles.length > 0)
			this.map.addLayer(this.vectorClusterPuntosInteresLayer);

		if (this.telefonosDisponibles.length > 0)
			this.map.addLayer(this.vectorClusterTelefonosLayer);

		if (this.vehiculosDisponibles.length > 0)
			this.map.addLayer(this.vectorClusterVehiculosLayer);
		if (this.portatilesDisponibles.length > 0)
			this.map.addLayer(this.vectorClusterPortatilesLayer);
	}

	ocultarProductos() {
		this.ocultarActivos();
		this.ocultarLectoras();
		this.ocultarMedidores();
		this.ocultarMicromedidores();
		this.ocultarPuntosInteres();
		this.ocultarTelefonos();
		this.ocultarVehiculos();
		this.ocultarPortatiles();
		this.ocultarApuntadorAlertas()
		this.ocultarPaneles();
	}

	mostrarProductos() {
		this.pintarMarcadoresActivos();
		this.mostrarActivos();

		this.pintarMarcadoresLectoras();
		this.mostrarLectoras();

		this.pintarMarcadoresMedidores();
		this.mostrarMedidores();

		this.pintarMarcadoresMicromedidores();
		this.mostrarMicromedidores();

		this.pintarMarcadoresPuntoInteres();
		this.mostrarPuntosInteres();

		this.pintarMarcadoresTelefonos();
		this.mostrarTelefonos();

		this.pintarMarcadoresPortatiles();
		this.mostrarPortatiles();

		this.pintarMarcadoresPaneles();
		this.mostrarPaneles();

		this.pintarMarcadoresVehiculos();
		this.mostrarVehiculos();
		this.mostrarApuntadorAlertas();
	}

	limpiarDispositivos() {
		this.activosDisponibles = [];
		this.lectorasDisponibles = [];
		this.medidoresDisponibles = [];
		this.micromedidoresDisponibles = [];
		this.telefonosDisponibles = [];
		this.vehiculosDisponibles = [];
		this.panelesDisponibles = [];
		//this.puntosInteresDisponibles = [];
	}

	/*API DIRECCION */
	public async getDireccion(coords: any) {
		/**Nuevo endpoint para la direccion
		 *
		*/
		const endpoint = `https://nominatim.openstreetmap.org/reverse?format=json&lon=${coords[0]}&lat=${coords[1]}`;
		return this.http.get<any[]>(endpoint).toPromise();;
	}


	/**Extras */
	wrapLon(value) {
		var worlds = Math.floor((value + 180) / 360);
		value = value - worlds * 360;
		return value
	}

	public getLocaleDateString(date) {
		let result = "";
		try {
			const aux = new Date(date);
			const options = { weekday: 'long', year: 'numeric', month: 'string', day: 'string' };
			const stringDate = aux.toLocaleDateString('es-MX', options);
			const time = aux.toLocaleTimeString('ex-MX', { hour12: true });
			result = `${stringDate} a las ${time}`;
		} catch (error) {
			result = date
		}
		return result;
	}

	public colorApuntador(estado) {
		let url = '';
		switch (estado) {
			case 0:
				//Detenido
				url = './assets/media/puntos/spinnerGris.png';
				break;
			case 1:
				//En movimiento
				url = './assets/media/puntos/spinner.png';
				break;
			case 2:
				//Alerta primaria (parpadeando)
				url = './assets/media/puntos/spinnerAlerta.png';
				break;
			case 3:
				url = './assets/media/puntos/spinnerAmarillo.png';
				break;
			case 4:
				//Detenido mas de 30 min
				url = './assets/media/puntos/spinnerAmarillo.png';
				break;
			case 5:
				//Detenido mas de 60 min
				url = './assets/media/puntos/spinnerNaranja.png';
				break;
			case 6:
				//Detenido mas de 90 min
				url = './assets/media/puntos/spinnerRojo.png';
				break;
			case 7:
				//Exceso de velocidad
				url = './assets/media/puntos/spinnerAzul.png';
				break;
			case 8:
				//Fuera geocerca
				url = './assets/media/puntos/spinnerMorado.png';
				break;
			case 9:
				//Bateria baja
				url = './assets/media/puntos/spinnerCafe.png';
				break;
			case 10:
				//Falta de energia
				url = './assets/media/puntos/spinnerRosa.png';
				break;
			case 11:
				//Alerta movimiento
				url = './assets/media/puntos/spinnerGris.png';
				break;
			default:
				url = './assets/media/puntos/spinnerRojo.png';
				break;
		}
		return url;
	}

	/***AQUI INICIA EL MODULO DE PANELES */

	public  verPanel(data: PanelCiudadano) {
		console.log("UBICANDO PANEL", data)
		this.apuntadorDispositivoPanel(data);
		this.map.getView().setCenter(fromLonLat([data.lng, data.lat]));
		if (this.map.getView().getZoom() < 15) {
			this.map.getView().setZoom(20);

		}
	}

	public apuntadorDispositivoPanel(coord) {
		this.vectorDispositivoUbicadoSource.clear();
		this.vectorDispositivoUbicadoLayer.setVisible(false);

		let coordenadas: Params = { lng: Number(coord.lng.toFixed(5)), lat: Number(coord.lat.toFixed(5)), zoom: 28 }
		this.auth.setStorageCoordinate(coordenadas);
		var pos = fromLonLat([coord.lng, coord.lat]);
		var dispositivoFeature = new Feature({
			type: 'puntoApuntadorAlerta',
			geometry: new Point(pos)
		});
		var iconStyleApuntador = new Style({
			image: new Icon({
				anchor: [0.5, 0.5],
				anchorXUnits: 'fraction',
				anchorYUnits: 'fraction',
				src: this.colorApuntador(coord.estado),
			}),
			zIndex: 10
		});
		dispositivoFeature.setStyle(iconStyleApuntador);
		this.vectorDispositivoUbicadoSource.addFeature(dispositivoFeature);
		this.vectorDispositivoUbicadoLayer.setVisible(true);
	}

		/**Desplegar Lectoras en Mapa*/
		public pintarPanelCiudadano = (panel: PanelCiudadano[]) => {
			this.panelesDisponibles = panel;
			console.log(this.panelesDisponibles, "PANEL DISPONIBLE")
			if (this.productosVisibles) {
				this.pintarMarcadoresPaneles();
			} else {
				this.pintarClusterPaneles();
			}
	
		}
	
		pintarClusterPaneles() {
			if (this.lectorasDisponibles.length > 0) {
				let source = new VectorSource({});
				let feature: Feature;
				let styleCache = {};
	
				this.panelesDisponibles.forEach(panel => {
					feature = new Feature({
						type: 'panel',
						idActivo: panel.numeroSerie,
						data: panel,
						dataTooltip: `divPanel${panel.numeroSerie}`,
						geometry: new Point(transform([panel.lng, panel.lat], 'EPSG:4326', 'EPSG:3857'))
					});
					source.addFeature(feature);
				});
	
				const CLUSTER = new Cluster({
					distance: 40,
					minDistance: 20,
					source: source,
				});
	
				this.vectorClusterPanelesLayer = new VectorLayer({
					source: CLUSTER,
					style: function (feature) {
						const size = feature.get('features').length;
						let style = styleCache[size];
						if (!style) {
							if (size > 1) {
								style = new Style({
									image: new Icon({
										anchor: [0.5, 0.5],
										anchorXUnits: 'fraction',
										anchorYUnits: 'fraction',
										src: './assets/image/paneles/Paneles.png'
									}),
									text: new Text({
										text: size.toString(),
										stroke: new Stroke({
											width: 1,
											color: '#fff',
										}),
										fill: new Fill({
											color: '#fff',
										}),
									}),
								});
								styleCache[size] = style;
							} else {
								style = new Style({
									image: new Icon({
										anchor: [0.5, 0.5],
										anchorXUnits: 'fraction',
										anchorYUnits: 'fraction',
										src: './assets/image/paneles/Paneles.png'
									}),
								});
								styleCache[size] = style;
							}
	
						}
						return style;
					},
				});
				this.map.addLayer(this.vectorClusterPanelesLayer);
			}
		}
	
		pintarMarcadoresPaneles() {
			if (this.panelesDisponibles.length > 0) {
				this.vectorPanelesSource.clear();
				this.panelesDisponibles.forEach(panel => {
					this.iconPanelesFeature = new Feature({
						type: 'panel',
						idTelefono: panel.descripcion,
						data: panel,
						dataTooltip: `divPanel${panel.descripcion}`,
						geometry: new Point(transform([panel.lng, panel.lat], 'EPSG:4326', 'EPSG:3857'))
					});
	
					this.iconPanelesStyle = new Style({
						image: new Icon({
							anchor: [0.5, 0.5],
							anchorXUnits: 'fraction',
							anchorYUnits: 'fraction',
							src: './assets/media/paneles/Paneles.png'
						}),
						zIndex: 10
					});
					this.iconPanelesFeature.setStyle(this.iconPanelesStyle);
					this.vectorPanelesSource.addFeature(this.iconPanelesFeature);
					const coordenadasFeature = this.iconPanelesFeature.getGeometry().getCoordinates();

					this.crearEtiquetaPanel(panel,coordenadasFeature)
				})
			}
		}
		async crearEtiquetaPanel(panel, coordenadasFeature) {

			let divTelefono = `divTelefono${panel.id}`;
			let overlayEtiqueta = this.map.getOverlayById(divTelefono);
	
			let yaExiste = overlayEtiqueta == null ? false : true;
			if (yaExiste && this.sonProductosFiltrados == false) {
				let idEstatus = `spanEstado${panel.id}`;
				let idIcono = `iGPS${panel.id}`;
				let iconGPS = <HTMLElement>document.getElementById(idIcono);
				let idLabel = `labelColor${panel.id}`;
				let divLabel = <HTMLElement>document.getElementById(idLabel);
		
				overlayEtiqueta.setPosition(coordenadasFeature);
			} else {
				let etiquetas = <HTMLDivElement>document.getElementById('etiquetas');
				let div = document.createElement('div');
//				let modelo = document.createTextNode(panel.numeroSerie);
				let br = document.createElement('div');
	
				br.style.display = 'block';
				br.style.width = '100%';
	
				let label = document.createElement('div');
				label.id = `labelColor${panel.id}`;
				label.style.border = '1px solid';
				label.style.lineHeight = '1.6em';
				label.style.marginTop = "3px";
				label.style.marginBottom = "3px";
				label.style.textAlign = 'center';
	
				let divBateria = document.createElement("div");
				divBateria.id = `divBateria${panel.id}`;
	
				let iconE = document.createElement("i");
				iconE.id = `iGPS${panel.id}`;
	
				let spanBateria = document.createElement("span");
				spanBateria.id = `spanBateriaTelefono${panel.id}`;
				let numeroSerie = document.createTextNode('Modelo: ' + panel.modelo);
				spanBateria.appendChild(numeroSerie);
	
				let spanGPS = document.createElement("span");
				spanGPS.id = `spanGPS${panel.modelo}`;
				let gps = document.createTextNode(panel.numeroSerie);
				spanGPS.appendChild(gps);
	
				let referencia = <HTMLDivElement>document.getElementById('map-content');
			//	div.appendChild(modelo);
				label.appendChild(iconE);
				label.appendChild(spanGPS);
				divBateria.appendChild(spanBateria);
	
	
				label.style.backgroundColor = 'green';
	
				
				div.appendChild(label);
				div.appendChild(divBateria);
				div.classList.add('ol-popupEtiqueta');
	
				let idClass = div.id = `divTelefono${panel.id}`;
				this.etiquetasTelefonos.push(idClass);
				etiquetas.parentNode.insertBefore(div, referencia);
	
				let containerEt = <HTMLDivElement>document.getElementById('divTelefono' + panel.id);
				let overlay = this.overlayEtiquetas = new Overlay({
					id: `divTelefono${panel.id}`,
					position: undefined,
					element: containerEt,
					idOverlay: `divTelefono${panel.id}`,
				});
				this.map.addOverlay(overlay);
				this.overlayEtiquetas.setPosition(coordenadasFeature);
			}
	
			return;
		}




		public ocultarPaneles() {
			if (this.panelesDisponibles.length > 0) {
				this.vectorPanelesLayer.setVisible(false);
			}
		}
	
		public mostrarPaneles() {
			if (this.lectorasDisponibles.length > 0) {
				this.vectorPanelesLayer.setVisible(true);
			}
		}

		


}
